// Ce fichier est généré automatiquement par utils/spritesheet-config-generator
// Ne pas modifier manuellement
// Dossier: lumephons | Taille: 460x460px

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const LumephonsSpritesheetConfig: ISpritesheetMetadata[] = [
  {
    name: 'lumephons-damage',
    metadata: {
      frames: {
        'lumephons-damage-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damage-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damage.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damage-bottom': [
          'lumephons-damage-bottom-0',
          'lumephons-damage-bottom-1',
        ],
        'lumephons-damage-bottom-left': [
          'lumephons-damage-bottom-left-0',
          'lumephons-damage-bottom-left-1',
        ],
        'lumephons-damage-left': [
          'lumephons-damage-left-0',
          'lumephons-damage-left-1',
        ],
        'lumephons-damage-top-left': [
          'lumephons-damage-top-left-0',
          'lumephons-damage-top-left-1',
        ],
        'lumephons-damage-top': [
          'lumephons-damage-top-0',
          'lumephons-damage-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingTool',
    metadata: {
      frames: {
        'lumephons-damageHoldingTool-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingTool-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingTool.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingTool-bottom': [
          'lumephons-damageHoldingTool-bottom-0',
          'lumephons-damageHoldingTool-bottom-1',
        ],
        'lumephons-damageHoldingTool-bottom-left': [
          'lumephons-damageHoldingTool-bottom-left-0',
          'lumephons-damageHoldingTool-bottom-left-1',
        ],
        'lumephons-damageHoldingTool-left': [
          'lumephons-damageHoldingTool-left-0',
          'lumephons-damageHoldingTool-left-1',
        ],
        'lumephons-damageHoldingTool-top-left': [
          'lumephons-damageHoldingTool-top-left-0',
          'lumephons-damageHoldingTool-top-left-1',
        ],
        'lumephons-damageHoldingTool-top': [
          'lumephons-damageHoldingTool-top-0',
          'lumephons-damageHoldingTool-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolAxe',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolAxe.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolAxe-bottom': [
          'lumephons-damageHoldingToolAxe-bottom-0',
          'lumephons-damageHoldingToolAxe-bottom-1',
        ],
        'lumephons-damageHoldingToolAxe-bottom-left': [
          'lumephons-damageHoldingToolAxe-bottom-left-0',
          'lumephons-damageHoldingToolAxe-bottom-left-1',
        ],
        'lumephons-damageHoldingToolAxe-left': [
          'lumephons-damageHoldingToolAxe-left-0',
          'lumephons-damageHoldingToolAxe-left-1',
        ],
        'lumephons-damageHoldingToolAxe-top-left': [
          'lumephons-damageHoldingToolAxe-top-left-0',
          'lumephons-damageHoldingToolAxe-top-left-1',
        ],
        'lumephons-damageHoldingToolAxe-top': [
          'lumephons-damageHoldingToolAxe-top-0',
          'lumephons-damageHoldingToolAxe-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolFishingPole',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolFishingPole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolFishingPole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolFishingPole.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolFishingPole-bottom': [
          'lumephons-damageHoldingToolFishingPole-bottom-0',
          'lumephons-damageHoldingToolFishingPole-bottom-1',
        ],
        'lumephons-damageHoldingToolFishingPole-bottom-left': [
          'lumephons-damageHoldingToolFishingPole-bottom-left-0',
          'lumephons-damageHoldingToolFishingPole-bottom-left-1',
        ],
        'lumephons-damageHoldingToolFishingPole-left': [
          'lumephons-damageHoldingToolFishingPole-left-0',
          'lumephons-damageHoldingToolFishingPole-left-1',
        ],
        'lumephons-damageHoldingToolFishingPole-top-left': [
          'lumephons-damageHoldingToolFishingPole-top-left-0',
          'lumephons-damageHoldingToolFishingPole-top-left-1',
        ],
        'lumephons-damageHoldingToolFishingPole-top': [
          'lumephons-damageHoldingToolFishingPole-top-0',
          'lumephons-damageHoldingToolFishingPole-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolHammer',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolHammer.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolHammer-bottom': [
          'lumephons-damageHoldingToolHammer-bottom-0',
          'lumephons-damageHoldingToolHammer-bottom-1',
        ],
        'lumephons-damageHoldingToolHammer-bottom-left': [
          'lumephons-damageHoldingToolHammer-bottom-left-0',
          'lumephons-damageHoldingToolHammer-bottom-left-1',
        ],
        'lumephons-damageHoldingToolHammer-left': [
          'lumephons-damageHoldingToolHammer-left-0',
          'lumephons-damageHoldingToolHammer-left-1',
        ],
        'lumephons-damageHoldingToolHammer-top-left': [
          'lumephons-damageHoldingToolHammer-top-left-0',
          'lumephons-damageHoldingToolHammer-top-left-1',
        ],
        'lumephons-damageHoldingToolHammer-top': [
          'lumephons-damageHoldingToolHammer-top-0',
          'lumephons-damageHoldingToolHammer-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolPickAxe',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolPickAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolPickAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolPickAxe.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolPickAxe-bottom': [
          'lumephons-damageHoldingToolPickAxe-bottom-0',
          'lumephons-damageHoldingToolPickAxe-bottom-1',
        ],
        'lumephons-damageHoldingToolPickAxe-bottom-left': [
          'lumephons-damageHoldingToolPickAxe-bottom-left-0',
          'lumephons-damageHoldingToolPickAxe-bottom-left-1',
        ],
        'lumephons-damageHoldingToolPickAxe-left': [
          'lumephons-damageHoldingToolPickAxe-left-0',
          'lumephons-damageHoldingToolPickAxe-left-1',
        ],
        'lumephons-damageHoldingToolPickAxe-top-left': [
          'lumephons-damageHoldingToolPickAxe-top-left-0',
          'lumephons-damageHoldingToolPickAxe-top-left-1',
        ],
        'lumephons-damageHoldingToolPickAxe-top': [
          'lumephons-damageHoldingToolPickAxe-top-0',
          'lumephons-damageHoldingToolPickAxe-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolShield',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolShield-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShield-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolShield.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolShield-bottom': [
          'lumephons-damageHoldingToolShield-bottom-0',
          'lumephons-damageHoldingToolShield-bottom-1',
        ],
        'lumephons-damageHoldingToolShield-bottom-left': [
          'lumephons-damageHoldingToolShield-bottom-left-0',
          'lumephons-damageHoldingToolShield-bottom-left-1',
        ],
        'lumephons-damageHoldingToolShield-left': [
          'lumephons-damageHoldingToolShield-left-0',
          'lumephons-damageHoldingToolShield-left-1',
        ],
        'lumephons-damageHoldingToolShield-top-left': [
          'lumephons-damageHoldingToolShield-top-left-0',
          'lumephons-damageHoldingToolShield-top-left-1',
        ],
        'lumephons-damageHoldingToolShield-top': [
          'lumephons-damageHoldingToolShield-top-0',
          'lumephons-damageHoldingToolShield-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolShowel',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolShowel.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolShowel-bottom': [
          'lumephons-damageHoldingToolShowel-bottom-0',
          'lumephons-damageHoldingToolShowel-bottom-1',
        ],
        'lumephons-damageHoldingToolShowel-bottom-left': [
          'lumephons-damageHoldingToolShowel-bottom-left-0',
          'lumephons-damageHoldingToolShowel-bottom-left-1',
        ],
        'lumephons-damageHoldingToolShowel-left': [
          'lumephons-damageHoldingToolShowel-left-0',
          'lumephons-damageHoldingToolShowel-left-1',
        ],
        'lumephons-damageHoldingToolShowel-top-left': [
          'lumephons-damageHoldingToolShowel-top-left-0',
          'lumephons-damageHoldingToolShowel-top-left-1',
        ],
        'lumephons-damageHoldingToolShowel-top': [
          'lumephons-damageHoldingToolShowel-top-0',
          'lumephons-damageHoldingToolShowel-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolSword',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolSword.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolSword-bottom': [
          'lumephons-damageHoldingToolSword-bottom-0',
          'lumephons-damageHoldingToolSword-bottom-1',
        ],
        'lumephons-damageHoldingToolSword-bottom-left': [
          'lumephons-damageHoldingToolSword-bottom-left-0',
          'lumephons-damageHoldingToolSword-bottom-left-1',
        ],
        'lumephons-damageHoldingToolSword-left': [
          'lumephons-damageHoldingToolSword-left-0',
          'lumephons-damageHoldingToolSword-left-1',
        ],
        'lumephons-damageHoldingToolSword-top-left': [
          'lumephons-damageHoldingToolSword-top-left-0',
          'lumephons-damageHoldingToolSword-top-left-1',
        ],
        'lumephons-damageHoldingToolSword-top': [
          'lumephons-damageHoldingToolSword-top-0',
          'lumephons-damageHoldingToolSword-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-damageHoldingToolWaterCan',
    metadata: {
      frames: {
        'lumephons-damageHoldingToolWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-damageHoldingToolWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/damageHoldingToolWaterCan.png',
        size: {
          w: 920,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-damageHoldingToolWaterCan-bottom': [
          'lumephons-damageHoldingToolWaterCan-bottom-0',
          'lumephons-damageHoldingToolWaterCan-bottom-1',
        ],
        'lumephons-damageHoldingToolWaterCan-bottom-left': [
          'lumephons-damageHoldingToolWaterCan-bottom-left-0',
          'lumephons-damageHoldingToolWaterCan-bottom-left-1',
        ],
        'lumephons-damageHoldingToolWaterCan-left': [
          'lumephons-damageHoldingToolWaterCan-left-0',
          'lumephons-damageHoldingToolWaterCan-left-1',
        ],
        'lumephons-damageHoldingToolWaterCan-top-left': [
          'lumephons-damageHoldingToolWaterCan-top-left-0',
          'lumephons-damageHoldingToolWaterCan-top-left-1',
        ],
        'lumephons-damageHoldingToolWaterCan-top': [
          'lumephons-damageHoldingToolWaterCan-top-0',
          'lumephons-damageHoldingToolWaterCan-top-1',
        ],
      },
    },
  },
  {
    name: 'lumephons-die',
    metadata: {
      frames: {
        'lumephons-die-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-die-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/die.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-die-bottom': [
          'lumephons-die-bottom-0',
          'lumephons-die-bottom-1',
          'lumephons-die-bottom-2',
          'lumephons-die-bottom-3',
          'lumephons-die-bottom-4',
          'lumephons-die-bottom-5',
        ],
        'lumephons-die-bottom-left': [
          'lumephons-die-bottom-left-0',
          'lumephons-die-bottom-left-1',
          'lumephons-die-bottom-left-2',
          'lumephons-die-bottom-left-3',
          'lumephons-die-bottom-left-4',
          'lumephons-die-bottom-left-5',
        ],
        'lumephons-die-left': [
          'lumephons-die-left-0',
          'lumephons-die-left-1',
          'lumephons-die-left-2',
          'lumephons-die-left-3',
          'lumephons-die-left-4',
          'lumephons-die-left-5',
        ],
        'lumephons-die-top-left': [
          'lumephons-die-top-left-0',
          'lumephons-die-top-left-1',
          'lumephons-die-top-left-2',
          'lumephons-die-top-left-3',
          'lumephons-die-top-left-4',
          'lumephons-die-top-left-5',
        ],
        'lumephons-die-top': [
          'lumephons-die-top-0',
          'lumephons-die-top-1',
          'lumephons-die-top-2',
          'lumephons-die-top-3',
          'lumephons-die-top-4',
          'lumephons-die-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUp',
    metadata: {
      frames: {
        'lumephons-getUp-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUp.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUp-bottom': [
          'lumephons-getUp-bottom-0',
          'lumephons-getUp-bottom-1',
          'lumephons-getUp-bottom-2',
          'lumephons-getUp-bottom-3',
        ],
        'lumephons-getUp-bottom-left': [
          'lumephons-getUp-bottom-left-0',
          'lumephons-getUp-bottom-left-1',
          'lumephons-getUp-bottom-left-2',
          'lumephons-getUp-bottom-left-3',
        ],
        'lumephons-getUp-left': [
          'lumephons-getUp-left-0',
          'lumephons-getUp-left-1',
          'lumephons-getUp-left-2',
          'lumephons-getUp-left-3',
        ],
        'lumephons-getUp-top-left': [
          'lumephons-getUp-top-left-0',
          'lumephons-getUp-top-left-1',
          'lumephons-getUp-top-left-2',
          'lumephons-getUp-top-left-3',
        ],
        'lumephons-getUp-top': [
          'lumephons-getUp-top-0',
          'lumephons-getUp-top-1',
          'lumephons-getUp-top-2',
          'lumephons-getUp-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-dig',
    metadata: {
      frames: {
        'lumephons-dig-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-dig-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/dig.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-dig-bottom': [
          'lumephons-dig-bottom-0',
          'lumephons-dig-bottom-1',
          'lumephons-dig-bottom-2',
          'lumephons-dig-bottom-3',
          'lumephons-dig-bottom-4',
          'lumephons-dig-bottom-5',
        ],
        'lumephons-dig-bottom-left': [
          'lumephons-dig-bottom-left-0',
          'lumephons-dig-bottom-left-1',
          'lumephons-dig-bottom-left-2',
          'lumephons-dig-bottom-left-3',
          'lumephons-dig-bottom-left-4',
          'lumephons-dig-bottom-left-5',
        ],
        'lumephons-dig-left': [
          'lumephons-dig-left-0',
          'lumephons-dig-left-1',
          'lumephons-dig-left-2',
          'lumephons-dig-left-3',
          'lumephons-dig-left-4',
          'lumephons-dig-left-5',
        ],
        'lumephons-dig-top-left': [
          'lumephons-dig-top-left-0',
          'lumephons-dig-top-left-1',
          'lumephons-dig-top-left-2',
          'lumephons-dig-top-left-3',
          'lumephons-dig-top-left-4',
          'lumephons-dig-top-left-5',
        ],
        'lumephons-dig-top': [
          'lumephons-dig-top-0',
          'lumephons-dig-top-1',
          'lumephons-dig-top-2',
          'lumephons-dig-top-3',
          'lumephons-dig-top-4',
          'lumephons-dig-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-digShowel',
    metadata: {
      frames: {
        'lumephons-digShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-digShowel-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/digShowel.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-digShowel-bottom': [
          'lumephons-digShowel-bottom-0',
          'lumephons-digShowel-bottom-1',
          'lumephons-digShowel-bottom-2',
          'lumephons-digShowel-bottom-3',
          'lumephons-digShowel-bottom-4',
          'lumephons-digShowel-bottom-5',
        ],
        'lumephons-digShowel-bottom-left': [
          'lumephons-digShowel-bottom-left-0',
          'lumephons-digShowel-bottom-left-1',
          'lumephons-digShowel-bottom-left-2',
          'lumephons-digShowel-bottom-left-3',
          'lumephons-digShowel-bottom-left-4',
          'lumephons-digShowel-bottom-left-5',
        ],
        'lumephons-digShowel-left': [
          'lumephons-digShowel-left-0',
          'lumephons-digShowel-left-1',
          'lumephons-digShowel-left-2',
          'lumephons-digShowel-left-3',
          'lumephons-digShowel-left-4',
          'lumephons-digShowel-left-5',
        ],
        'lumephons-digShowel-top-left': [
          'lumephons-digShowel-top-left-0',
          'lumephons-digShowel-top-left-1',
          'lumephons-digShowel-top-left-2',
          'lumephons-digShowel-top-left-3',
          'lumephons-digShowel-top-left-4',
          'lumephons-digShowel-top-left-5',
        ],
        'lumephons-digShowel-top': [
          'lumephons-digShowel-top-0',
          'lumephons-digShowel-top-1',
          'lumephons-digShowel-top-2',
          'lumephons-digShowel-top-3',
          'lumephons-digShowel-top-4',
          'lumephons-digShowel-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-fish',
    metadata: {
      frames: {
        'lumephons-fish-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fish-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/fish.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-fish-bottom': [
          'lumephons-fish-bottom-0',
          'lumephons-fish-bottom-1',
          'lumephons-fish-bottom-2',
          'lumephons-fish-bottom-3',
          'lumephons-fish-bottom-4',
          'lumephons-fish-bottom-5',
        ],
        'lumephons-fish-bottom-left': [
          'lumephons-fish-bottom-left-0',
          'lumephons-fish-bottom-left-1',
          'lumephons-fish-bottom-left-2',
          'lumephons-fish-bottom-left-3',
          'lumephons-fish-bottom-left-4',
          'lumephons-fish-bottom-left-5',
        ],
        'lumephons-fish-left': [
          'lumephons-fish-left-0',
          'lumephons-fish-left-1',
          'lumephons-fish-left-2',
          'lumephons-fish-left-3',
          'lumephons-fish-left-4',
          'lumephons-fish-left-5',
        ],
        'lumephons-fish-top-left': [
          'lumephons-fish-top-left-0',
          'lumephons-fish-top-left-1',
          'lumephons-fish-top-left-2',
          'lumephons-fish-top-left-3',
          'lumephons-fish-top-left-4',
          'lumephons-fish-top-left-5',
        ],
        'lumephons-fish-top': [
          'lumephons-fish-top-0',
          'lumephons-fish-top-1',
          'lumephons-fish-top-2',
          'lumephons-fish-top-3',
          'lumephons-fish-top-4',
          'lumephons-fish-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-fishFishingpole',
    metadata: {
      frames: {
        'lumephons-fishFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-fishFishingpole-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/fishFishingpole.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-fishFishingpole-bottom': [
          'lumephons-fishFishingpole-bottom-0',
          'lumephons-fishFishingpole-bottom-1',
          'lumephons-fishFishingpole-bottom-2',
          'lumephons-fishFishingpole-bottom-3',
          'lumephons-fishFishingpole-bottom-4',
          'lumephons-fishFishingpole-bottom-5',
        ],
        'lumephons-fishFishingpole-bottom-left': [
          'lumephons-fishFishingpole-bottom-left-0',
          'lumephons-fishFishingpole-bottom-left-1',
          'lumephons-fishFishingpole-bottom-left-2',
          'lumephons-fishFishingpole-bottom-left-3',
          'lumephons-fishFishingpole-bottom-left-4',
          'lumephons-fishFishingpole-bottom-left-5',
        ],
        'lumephons-fishFishingpole-left': [
          'lumephons-fishFishingpole-left-0',
          'lumephons-fishFishingpole-left-1',
          'lumephons-fishFishingpole-left-2',
          'lumephons-fishFishingpole-left-3',
          'lumephons-fishFishingpole-left-4',
          'lumephons-fishFishingpole-left-5',
        ],
        'lumephons-fishFishingpole-top-left': [
          'lumephons-fishFishingpole-top-left-0',
          'lumephons-fishFishingpole-top-left-1',
          'lumephons-fishFishingpole-top-left-2',
          'lumephons-fishFishingpole-top-left-3',
          'lumephons-fishFishingpole-top-left-4',
          'lumephons-fishFishingpole-top-left-5',
        ],
        'lumephons-fishFishingpole-top': [
          'lumephons-fishFishingpole-top-0',
          'lumephons-fishFishingpole-top-1',
          'lumephons-fishFishingpole-top-2',
          'lumephons-fishFishingpole-top-3',
          'lumephons-fishFishingpole-top-4',
          'lumephons-fishFishingpole-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUp',
    metadata: {
      frames: {
        'lumephons-getUp-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUp-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUp.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUp-bottom': [
          'lumephons-getUp-bottom-0',
          'lumephons-getUp-bottom-1',
          'lumephons-getUp-bottom-2',
          'lumephons-getUp-bottom-3',
        ],
        'lumephons-getUp-bottom-left': [
          'lumephons-getUp-bottom-left-0',
          'lumephons-getUp-bottom-left-1',
          'lumephons-getUp-bottom-left-2',
          'lumephons-getUp-bottom-left-3',
        ],
        'lumephons-getUp-left': [
          'lumephons-getUp-left-0',
          'lumephons-getUp-left-1',
          'lumephons-getUp-left-2',
          'lumephons-getUp-left-3',
        ],
        'lumephons-getUp-top-left': [
          'lumephons-getUp-top-left-0',
          'lumephons-getUp-top-left-1',
          'lumephons-getUp-top-left-2',
          'lumephons-getUp-top-left-3',
        ],
        'lumephons-getUp-top': [
          'lumephons-getUp-top-0',
          'lumephons-getUp-top-1',
          'lumephons-getUp-top-2',
          'lumephons-getUp-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingTool',
    metadata: {
      frames: {
        'lumephons-getUpHoldingTool-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingTool-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingTool.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingTool-bottom': [
          'lumephons-getUpHoldingTool-bottom-0',
          'lumephons-getUpHoldingTool-bottom-1',
          'lumephons-getUpHoldingTool-bottom-2',
          'lumephons-getUpHoldingTool-bottom-3',
        ],
        'lumephons-getUpHoldingTool-bottom-left': [
          'lumephons-getUpHoldingTool-bottom-left-0',
          'lumephons-getUpHoldingTool-bottom-left-1',
          'lumephons-getUpHoldingTool-bottom-left-2',
          'lumephons-getUpHoldingTool-bottom-left-3',
        ],
        'lumephons-getUpHoldingTool-left': [
          'lumephons-getUpHoldingTool-left-0',
          'lumephons-getUpHoldingTool-left-1',
          'lumephons-getUpHoldingTool-left-2',
          'lumephons-getUpHoldingTool-left-3',
        ],
        'lumephons-getUpHoldingTool-top-left': [
          'lumephons-getUpHoldingTool-top-left-0',
          'lumephons-getUpHoldingTool-top-left-1',
          'lumephons-getUpHoldingTool-top-left-2',
          'lumephons-getUpHoldingTool-top-left-3',
        ],
        'lumephons-getUpHoldingTool-top': [
          'lumephons-getUpHoldingTool-top-0',
          'lumephons-getUpHoldingTool-top-1',
          'lumephons-getUpHoldingTool-top-2',
          'lumephons-getUpHoldingTool-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolAxe',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolAxe.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolAxe-bottom': [
          'lumephons-getUpHoldingToolAxe-bottom-0',
          'lumephons-getUpHoldingToolAxe-bottom-1',
          'lumephons-getUpHoldingToolAxe-bottom-2',
          'lumephons-getUpHoldingToolAxe-bottom-3',
        ],
        'lumephons-getUpHoldingToolAxe-bottom-left': [
          'lumephons-getUpHoldingToolAxe-bottom-left-0',
          'lumephons-getUpHoldingToolAxe-bottom-left-1',
          'lumephons-getUpHoldingToolAxe-bottom-left-2',
          'lumephons-getUpHoldingToolAxe-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolAxe-left': [
          'lumephons-getUpHoldingToolAxe-left-0',
          'lumephons-getUpHoldingToolAxe-left-1',
          'lumephons-getUpHoldingToolAxe-left-2',
          'lumephons-getUpHoldingToolAxe-left-3',
        ],
        'lumephons-getUpHoldingToolAxe-top-left': [
          'lumephons-getUpHoldingToolAxe-top-left-0',
          'lumephons-getUpHoldingToolAxe-top-left-1',
          'lumephons-getUpHoldingToolAxe-top-left-2',
          'lumephons-getUpHoldingToolAxe-top-left-3',
        ],
        'lumephons-getUpHoldingToolAxe-top': [
          'lumephons-getUpHoldingToolAxe-top-0',
          'lumephons-getUpHoldingToolAxe-top-1',
          'lumephons-getUpHoldingToolAxe-top-2',
          'lumephons-getUpHoldingToolAxe-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolFishingpole',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolFishingpole-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolFishingpole.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolFishingpole-bottom': [
          'lumephons-getUpHoldingToolFishingpole-bottom-0',
          'lumephons-getUpHoldingToolFishingpole-bottom-1',
          'lumephons-getUpHoldingToolFishingpole-bottom-2',
          'lumephons-getUpHoldingToolFishingpole-bottom-3',
        ],
        'lumephons-getUpHoldingToolFishingpole-bottom-left': [
          'lumephons-getUpHoldingToolFishingpole-bottom-left-0',
          'lumephons-getUpHoldingToolFishingpole-bottom-left-1',
          'lumephons-getUpHoldingToolFishingpole-bottom-left-2',
          'lumephons-getUpHoldingToolFishingpole-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolFishingpole-left': [
          'lumephons-getUpHoldingToolFishingpole-left-0',
          'lumephons-getUpHoldingToolFishingpole-left-1',
          'lumephons-getUpHoldingToolFishingpole-left-2',
          'lumephons-getUpHoldingToolFishingpole-left-3',
        ],
        'lumephons-getUpHoldingToolFishingpole-top-left': [
          'lumephons-getUpHoldingToolFishingpole-top-left-0',
          'lumephons-getUpHoldingToolFishingpole-top-left-1',
          'lumephons-getUpHoldingToolFishingpole-top-left-2',
          'lumephons-getUpHoldingToolFishingpole-top-left-3',
        ],
        'lumephons-getUpHoldingToolFishingpole-top': [
          'lumephons-getUpHoldingToolFishingpole-top-0',
          'lumephons-getUpHoldingToolFishingpole-top-1',
          'lumephons-getUpHoldingToolFishingpole-top-2',
          'lumephons-getUpHoldingToolFishingpole-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolHammer',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolHammer-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolHammer.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolHammer-bottom': [
          'lumephons-getUpHoldingToolHammer-bottom-0',
          'lumephons-getUpHoldingToolHammer-bottom-1',
          'lumephons-getUpHoldingToolHammer-bottom-2',
          'lumephons-getUpHoldingToolHammer-bottom-3',
        ],
        'lumephons-getUpHoldingToolHammer-bottom-left': [
          'lumephons-getUpHoldingToolHammer-bottom-left-0',
          'lumephons-getUpHoldingToolHammer-bottom-left-1',
          'lumephons-getUpHoldingToolHammer-bottom-left-2',
          'lumephons-getUpHoldingToolHammer-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolHammer-left': [
          'lumephons-getUpHoldingToolHammer-left-0',
          'lumephons-getUpHoldingToolHammer-left-1',
          'lumephons-getUpHoldingToolHammer-left-2',
          'lumephons-getUpHoldingToolHammer-left-3',
        ],
        'lumephons-getUpHoldingToolHammer-top-left': [
          'lumephons-getUpHoldingToolHammer-top-left-0',
          'lumephons-getUpHoldingToolHammer-top-left-1',
          'lumephons-getUpHoldingToolHammer-top-left-2',
          'lumephons-getUpHoldingToolHammer-top-left-3',
        ],
        'lumephons-getUpHoldingToolHammer-top': [
          'lumephons-getUpHoldingToolHammer-top-0',
          'lumephons-getUpHoldingToolHammer-top-1',
          'lumephons-getUpHoldingToolHammer-top-2',
          'lumephons-getUpHoldingToolHammer-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolPickaxe',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolPickaxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolPickaxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolPickaxe.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolPickaxe-bottom': [
          'lumephons-getUpHoldingToolPickaxe-bottom-0',
          'lumephons-getUpHoldingToolPickaxe-bottom-1',
          'lumephons-getUpHoldingToolPickaxe-bottom-2',
          'lumephons-getUpHoldingToolPickaxe-bottom-3',
        ],
        'lumephons-getUpHoldingToolPickaxe-bottom-left': [
          'lumephons-getUpHoldingToolPickaxe-bottom-left-0',
          'lumephons-getUpHoldingToolPickaxe-bottom-left-1',
          'lumephons-getUpHoldingToolPickaxe-bottom-left-2',
          'lumephons-getUpHoldingToolPickaxe-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolPickaxe-left': [
          'lumephons-getUpHoldingToolPickaxe-left-0',
          'lumephons-getUpHoldingToolPickaxe-left-1',
          'lumephons-getUpHoldingToolPickaxe-left-2',
          'lumephons-getUpHoldingToolPickaxe-left-3',
        ],
        'lumephons-getUpHoldingToolPickaxe-top-left': [
          'lumephons-getUpHoldingToolPickaxe-top-left-0',
          'lumephons-getUpHoldingToolPickaxe-top-left-1',
          'lumephons-getUpHoldingToolPickaxe-top-left-2',
          'lumephons-getUpHoldingToolPickaxe-top-left-3',
        ],
        'lumephons-getUpHoldingToolPickaxe-top': [
          'lumephons-getUpHoldingToolPickaxe-top-0',
          'lumephons-getUpHoldingToolPickaxe-top-1',
          'lumephons-getUpHoldingToolPickaxe-top-2',
          'lumephons-getUpHoldingToolPickaxe-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolShield',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolShield-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShield-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolShield.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolShield-bottom': [
          'lumephons-getUpHoldingToolShield-bottom-0',
          'lumephons-getUpHoldingToolShield-bottom-1',
          'lumephons-getUpHoldingToolShield-bottom-2',
          'lumephons-getUpHoldingToolShield-bottom-3',
        ],
        'lumephons-getUpHoldingToolShield-bottom-left': [
          'lumephons-getUpHoldingToolShield-bottom-left-0',
          'lumephons-getUpHoldingToolShield-bottom-left-1',
          'lumephons-getUpHoldingToolShield-bottom-left-2',
          'lumephons-getUpHoldingToolShield-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolShield-left': [
          'lumephons-getUpHoldingToolShield-left-0',
          'lumephons-getUpHoldingToolShield-left-1',
          'lumephons-getUpHoldingToolShield-left-2',
          'lumephons-getUpHoldingToolShield-left-3',
        ],
        'lumephons-getUpHoldingToolShield-top-left': [
          'lumephons-getUpHoldingToolShield-top-left-0',
          'lumephons-getUpHoldingToolShield-top-left-1',
          'lumephons-getUpHoldingToolShield-top-left-2',
          'lumephons-getUpHoldingToolShield-top-left-3',
        ],
        'lumephons-getUpHoldingToolShield-top': [
          'lumephons-getUpHoldingToolShield-top-0',
          'lumephons-getUpHoldingToolShield-top-1',
          'lumephons-getUpHoldingToolShield-top-2',
          'lumephons-getUpHoldingToolShield-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolShowel',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolShowel-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolShowel.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolShowel-bottom': [
          'lumephons-getUpHoldingToolShowel-bottom-0',
          'lumephons-getUpHoldingToolShowel-bottom-1',
          'lumephons-getUpHoldingToolShowel-bottom-2',
          'lumephons-getUpHoldingToolShowel-bottom-3',
        ],
        'lumephons-getUpHoldingToolShowel-bottom-left': [
          'lumephons-getUpHoldingToolShowel-bottom-left-0',
          'lumephons-getUpHoldingToolShowel-bottom-left-1',
          'lumephons-getUpHoldingToolShowel-bottom-left-2',
          'lumephons-getUpHoldingToolShowel-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolShowel-left': [
          'lumephons-getUpHoldingToolShowel-left-0',
          'lumephons-getUpHoldingToolShowel-left-1',
          'lumephons-getUpHoldingToolShowel-left-2',
          'lumephons-getUpHoldingToolShowel-left-3',
        ],
        'lumephons-getUpHoldingToolShowel-top-left': [
          'lumephons-getUpHoldingToolShowel-top-left-0',
          'lumephons-getUpHoldingToolShowel-top-left-1',
          'lumephons-getUpHoldingToolShowel-top-left-2',
          'lumephons-getUpHoldingToolShowel-top-left-3',
        ],
        'lumephons-getUpHoldingToolShowel-top': [
          'lumephons-getUpHoldingToolShowel-top-0',
          'lumephons-getUpHoldingToolShowel-top-1',
          'lumephons-getUpHoldingToolShowel-top-2',
          'lumephons-getUpHoldingToolShowel-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolSword',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolSword-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolSword.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolSword-bottom': [
          'lumephons-getUpHoldingToolSword-bottom-0',
          'lumephons-getUpHoldingToolSword-bottom-1',
          'lumephons-getUpHoldingToolSword-bottom-2',
          'lumephons-getUpHoldingToolSword-bottom-3',
        ],
        'lumephons-getUpHoldingToolSword-bottom-left': [
          'lumephons-getUpHoldingToolSword-bottom-left-0',
          'lumephons-getUpHoldingToolSword-bottom-left-1',
          'lumephons-getUpHoldingToolSword-bottom-left-2',
          'lumephons-getUpHoldingToolSword-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolSword-left': [
          'lumephons-getUpHoldingToolSword-left-0',
          'lumephons-getUpHoldingToolSword-left-1',
          'lumephons-getUpHoldingToolSword-left-2',
          'lumephons-getUpHoldingToolSword-left-3',
        ],
        'lumephons-getUpHoldingToolSword-top-left': [
          'lumephons-getUpHoldingToolSword-top-left-0',
          'lumephons-getUpHoldingToolSword-top-left-1',
          'lumephons-getUpHoldingToolSword-top-left-2',
          'lumephons-getUpHoldingToolSword-top-left-3',
        ],
        'lumephons-getUpHoldingToolSword-top': [
          'lumephons-getUpHoldingToolSword-top-0',
          'lumephons-getUpHoldingToolSword-top-1',
          'lumephons-getUpHoldingToolSword-top-2',
          'lumephons-getUpHoldingToolSword-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-getUpHoldingToolWaterCan',
    metadata: {
      frames: {
        'lumephons-getUpHoldingToolWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-getUpHoldingToolWaterCan-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/getUpHoldingToolWaterCan.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-getUpHoldingToolWaterCan-bottom': [
          'lumephons-getUpHoldingToolWaterCan-bottom-0',
          'lumephons-getUpHoldingToolWaterCan-bottom-1',
          'lumephons-getUpHoldingToolWaterCan-bottom-2',
          'lumephons-getUpHoldingToolWaterCan-bottom-3',
        ],
        'lumephons-getUpHoldingToolWaterCan-bottom-left': [
          'lumephons-getUpHoldingToolWaterCan-bottom-left-0',
          'lumephons-getUpHoldingToolWaterCan-bottom-left-1',
          'lumephons-getUpHoldingToolWaterCan-bottom-left-2',
          'lumephons-getUpHoldingToolWaterCan-bottom-left-3',
        ],
        'lumephons-getUpHoldingToolWaterCan-left': [
          'lumephons-getUpHoldingToolWaterCan-left-0',
          'lumephons-getUpHoldingToolWaterCan-left-1',
          'lumephons-getUpHoldingToolWaterCan-left-2',
          'lumephons-getUpHoldingToolWaterCan-left-3',
        ],
        'lumephons-getUpHoldingToolWaterCan-top-left': [
          'lumephons-getUpHoldingToolWaterCan-top-left-0',
          'lumephons-getUpHoldingToolWaterCan-top-left-1',
          'lumephons-getUpHoldingToolWaterCan-top-left-2',
          'lumephons-getUpHoldingToolWaterCan-top-left-3',
        ],
        'lumephons-getUpHoldingToolWaterCan-top': [
          'lumephons-getUpHoldingToolWaterCan-top-0',
          'lumephons-getUpHoldingToolWaterCan-top-1',
          'lumephons-getUpHoldingToolWaterCan-top-2',
          'lumephons-getUpHoldingToolWaterCan-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-idle',
    metadata: {
      frames: {
        'lumephons-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idle-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idle.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idle-bottom': [
          'lumephons-idle-bottom-0',
          'lumephons-idle-bottom-1',
          'lumephons-idle-bottom-2',
          'lumephons-idle-bottom-3',
          'lumephons-idle-bottom-4',
          'lumephons-idle-bottom-5',
          'lumephons-idle-bottom-6',
          'lumephons-idle-bottom-7',
        ],
        'lumephons-idle-bottom-left': [
          'lumephons-idle-bottom-left-0',
          'lumephons-idle-bottom-left-1',
          'lumephons-idle-bottom-left-2',
          'lumephons-idle-bottom-left-3',
          'lumephons-idle-bottom-left-4',
          'lumephons-idle-bottom-left-5',
          'lumephons-idle-bottom-left-6',
          'lumephons-idle-bottom-left-7',
        ],
        'lumephons-idle-left': [
          'lumephons-idle-left-0',
          'lumephons-idle-left-1',
          'lumephons-idle-left-2',
          'lumephons-idle-left-3',
          'lumephons-idle-left-4',
          'lumephons-idle-left-5',
          'lumephons-idle-left-6',
          'lumephons-idle-left-7',
        ],
        'lumephons-idle-top-left': [
          'lumephons-idle-top-left-0',
          'lumephons-idle-top-left-1',
          'lumephons-idle-top-left-2',
          'lumephons-idle-top-left-3',
          'lumephons-idle-top-left-4',
          'lumephons-idle-top-left-5',
          'lumephons-idle-top-left-6',
          'lumephons-idle-top-left-7',
        ],
        'lumephons-idle-top': [
          'lumephons-idle-top-0',
          'lumephons-idle-top-1',
          'lumephons-idle-top-2',
          'lumephons-idle-top-3',
          'lumephons-idle-top-4',
          'lumephons-idle-top-5',
          'lumephons-idle-top-6',
          'lumephons-idle-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingTool',
    metadata: {
      frames: {
        'lumephons-idleHoldingTool-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingTool-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingTool.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingTool-bottom': [
          'lumephons-idleHoldingTool-bottom-0',
          'lumephons-idleHoldingTool-bottom-1',
          'lumephons-idleHoldingTool-bottom-2',
          'lumephons-idleHoldingTool-bottom-3',
          'lumephons-idleHoldingTool-bottom-4',
          'lumephons-idleHoldingTool-bottom-5',
          'lumephons-idleHoldingTool-bottom-6',
          'lumephons-idleHoldingTool-bottom-7',
        ],
        'lumephons-idleHoldingTool-bottom-left': [
          'lumephons-idleHoldingTool-bottom-left-0',
          'lumephons-idleHoldingTool-bottom-left-1',
          'lumephons-idleHoldingTool-bottom-left-2',
          'lumephons-idleHoldingTool-bottom-left-3',
          'lumephons-idleHoldingTool-bottom-left-4',
          'lumephons-idleHoldingTool-bottom-left-5',
          'lumephons-idleHoldingTool-bottom-left-6',
          'lumephons-idleHoldingTool-bottom-left-7',
        ],
        'lumephons-idleHoldingTool-left': [
          'lumephons-idleHoldingTool-left-0',
          'lumephons-idleHoldingTool-left-1',
          'lumephons-idleHoldingTool-left-2',
          'lumephons-idleHoldingTool-left-3',
          'lumephons-idleHoldingTool-left-4',
          'lumephons-idleHoldingTool-left-5',
          'lumephons-idleHoldingTool-left-6',
          'lumephons-idleHoldingTool-left-7',
        ],
        'lumephons-idleHoldingTool-top-left': [
          'lumephons-idleHoldingTool-top-left-0',
          'lumephons-idleHoldingTool-top-left-1',
          'lumephons-idleHoldingTool-top-left-2',
          'lumephons-idleHoldingTool-top-left-3',
          'lumephons-idleHoldingTool-top-left-4',
          'lumephons-idleHoldingTool-top-left-5',
          'lumephons-idleHoldingTool-top-left-6',
          'lumephons-idleHoldingTool-top-left-7',
        ],
        'lumephons-idleHoldingTool-top': [
          'lumephons-idleHoldingTool-top-0',
          'lumephons-idleHoldingTool-top-1',
          'lumephons-idleHoldingTool-top-2',
          'lumephons-idleHoldingTool-top-3',
          'lumephons-idleHoldingTool-top-4',
          'lumephons-idleHoldingTool-top-5',
          'lumephons-idleHoldingTool-top-6',
          'lumephons-idleHoldingTool-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolAxe',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolAxe-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolAxe.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolAxe-bottom': [
          'lumephons-idleHoldingToolAxe-bottom-0',
          'lumephons-idleHoldingToolAxe-bottom-1',
          'lumephons-idleHoldingToolAxe-bottom-2',
          'lumephons-idleHoldingToolAxe-bottom-3',
          'lumephons-idleHoldingToolAxe-bottom-4',
          'lumephons-idleHoldingToolAxe-bottom-5',
          'lumephons-idleHoldingToolAxe-bottom-6',
          'lumephons-idleHoldingToolAxe-bottom-7',
        ],
        'lumephons-idleHoldingToolAxe-bottom-left': [
          'lumephons-idleHoldingToolAxe-bottom-left-0',
          'lumephons-idleHoldingToolAxe-bottom-left-1',
          'lumephons-idleHoldingToolAxe-bottom-left-2',
          'lumephons-idleHoldingToolAxe-bottom-left-3',
          'lumephons-idleHoldingToolAxe-bottom-left-4',
          'lumephons-idleHoldingToolAxe-bottom-left-5',
          'lumephons-idleHoldingToolAxe-bottom-left-6',
          'lumephons-idleHoldingToolAxe-bottom-left-7',
        ],
        'lumephons-idleHoldingToolAxe-left': [
          'lumephons-idleHoldingToolAxe-left-0',
          'lumephons-idleHoldingToolAxe-left-1',
          'lumephons-idleHoldingToolAxe-left-2',
          'lumephons-idleHoldingToolAxe-left-3',
          'lumephons-idleHoldingToolAxe-left-4',
          'lumephons-idleHoldingToolAxe-left-5',
          'lumephons-idleHoldingToolAxe-left-6',
          'lumephons-idleHoldingToolAxe-left-7',
        ],
        'lumephons-idleHoldingToolAxe-top-left': [
          'lumephons-idleHoldingToolAxe-top-left-0',
          'lumephons-idleHoldingToolAxe-top-left-1',
          'lumephons-idleHoldingToolAxe-top-left-2',
          'lumephons-idleHoldingToolAxe-top-left-3',
          'lumephons-idleHoldingToolAxe-top-left-4',
          'lumephons-idleHoldingToolAxe-top-left-5',
          'lumephons-idleHoldingToolAxe-top-left-6',
          'lumephons-idleHoldingToolAxe-top-left-7',
        ],
        'lumephons-idleHoldingToolAxe-top': [
          'lumephons-idleHoldingToolAxe-top-0',
          'lumephons-idleHoldingToolAxe-top-1',
          'lumephons-idleHoldingToolAxe-top-2',
          'lumephons-idleHoldingToolAxe-top-3',
          'lumephons-idleHoldingToolAxe-top-4',
          'lumephons-idleHoldingToolAxe-top-5',
          'lumephons-idleHoldingToolAxe-top-6',
          'lumephons-idleHoldingToolAxe-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolFishingpole',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolFishingpole-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolFishingpole.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolFishingpole-bottom': [
          'lumephons-idleHoldingToolFishingpole-bottom-0',
          'lumephons-idleHoldingToolFishingpole-bottom-1',
          'lumephons-idleHoldingToolFishingpole-bottom-2',
          'lumephons-idleHoldingToolFishingpole-bottom-3',
          'lumephons-idleHoldingToolFishingpole-bottom-4',
          'lumephons-idleHoldingToolFishingpole-bottom-5',
          'lumephons-idleHoldingToolFishingpole-bottom-6',
          'lumephons-idleHoldingToolFishingpole-bottom-7',
        ],
        'lumephons-idleHoldingToolFishingpole-bottom-left': [
          'lumephons-idleHoldingToolFishingpole-bottom-left-0',
          'lumephons-idleHoldingToolFishingpole-bottom-left-1',
          'lumephons-idleHoldingToolFishingpole-bottom-left-2',
          'lumephons-idleHoldingToolFishingpole-bottom-left-3',
          'lumephons-idleHoldingToolFishingpole-bottom-left-4',
          'lumephons-idleHoldingToolFishingpole-bottom-left-5',
          'lumephons-idleHoldingToolFishingpole-bottom-left-6',
          'lumephons-idleHoldingToolFishingpole-bottom-left-7',
        ],
        'lumephons-idleHoldingToolFishingpole-left': [
          'lumephons-idleHoldingToolFishingpole-left-0',
          'lumephons-idleHoldingToolFishingpole-left-1',
          'lumephons-idleHoldingToolFishingpole-left-2',
          'lumephons-idleHoldingToolFishingpole-left-3',
          'lumephons-idleHoldingToolFishingpole-left-4',
          'lumephons-idleHoldingToolFishingpole-left-5',
          'lumephons-idleHoldingToolFishingpole-left-6',
          'lumephons-idleHoldingToolFishingpole-left-7',
        ],
        'lumephons-idleHoldingToolFishingpole-top-left': [
          'lumephons-idleHoldingToolFishingpole-top-left-0',
          'lumephons-idleHoldingToolFishingpole-top-left-1',
          'lumephons-idleHoldingToolFishingpole-top-left-2',
          'lumephons-idleHoldingToolFishingpole-top-left-3',
          'lumephons-idleHoldingToolFishingpole-top-left-4',
          'lumephons-idleHoldingToolFishingpole-top-left-5',
          'lumephons-idleHoldingToolFishingpole-top-left-6',
          'lumephons-idleHoldingToolFishingpole-top-left-7',
        ],
        'lumephons-idleHoldingToolFishingpole-top': [
          'lumephons-idleHoldingToolFishingpole-top-0',
          'lumephons-idleHoldingToolFishingpole-top-1',
          'lumephons-idleHoldingToolFishingpole-top-2',
          'lumephons-idleHoldingToolFishingpole-top-3',
          'lumephons-idleHoldingToolFishingpole-top-4',
          'lumephons-idleHoldingToolFishingpole-top-5',
          'lumephons-idleHoldingToolFishingpole-top-6',
          'lumephons-idleHoldingToolFishingpole-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolHammer',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolHammer-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolHammer.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolHammer-bottom': [
          'lumephons-idleHoldingToolHammer-bottom-0',
          'lumephons-idleHoldingToolHammer-bottom-1',
          'lumephons-idleHoldingToolHammer-bottom-2',
          'lumephons-idleHoldingToolHammer-bottom-3',
          'lumephons-idleHoldingToolHammer-bottom-4',
          'lumephons-idleHoldingToolHammer-bottom-5',
          'lumephons-idleHoldingToolHammer-bottom-6',
          'lumephons-idleHoldingToolHammer-bottom-7',
        ],
        'lumephons-idleHoldingToolHammer-bottom-left': [
          'lumephons-idleHoldingToolHammer-bottom-left-0',
          'lumephons-idleHoldingToolHammer-bottom-left-1',
          'lumephons-idleHoldingToolHammer-bottom-left-2',
          'lumephons-idleHoldingToolHammer-bottom-left-3',
          'lumephons-idleHoldingToolHammer-bottom-left-4',
          'lumephons-idleHoldingToolHammer-bottom-left-5',
          'lumephons-idleHoldingToolHammer-bottom-left-6',
          'lumephons-idleHoldingToolHammer-bottom-left-7',
        ],
        'lumephons-idleHoldingToolHammer-left': [
          'lumephons-idleHoldingToolHammer-left-0',
          'lumephons-idleHoldingToolHammer-left-1',
          'lumephons-idleHoldingToolHammer-left-2',
          'lumephons-idleHoldingToolHammer-left-3',
          'lumephons-idleHoldingToolHammer-left-4',
          'lumephons-idleHoldingToolHammer-left-5',
          'lumephons-idleHoldingToolHammer-left-6',
          'lumephons-idleHoldingToolHammer-left-7',
        ],
        'lumephons-idleHoldingToolHammer-top-left': [
          'lumephons-idleHoldingToolHammer-top-left-0',
          'lumephons-idleHoldingToolHammer-top-left-1',
          'lumephons-idleHoldingToolHammer-top-left-2',
          'lumephons-idleHoldingToolHammer-top-left-3',
          'lumephons-idleHoldingToolHammer-top-left-4',
          'lumephons-idleHoldingToolHammer-top-left-5',
          'lumephons-idleHoldingToolHammer-top-left-6',
          'lumephons-idleHoldingToolHammer-top-left-7',
        ],
        'lumephons-idleHoldingToolHammer-top': [
          'lumephons-idleHoldingToolHammer-top-0',
          'lumephons-idleHoldingToolHammer-top-1',
          'lumephons-idleHoldingToolHammer-top-2',
          'lumephons-idleHoldingToolHammer-top-3',
          'lumephons-idleHoldingToolHammer-top-4',
          'lumephons-idleHoldingToolHammer-top-5',
          'lumephons-idleHoldingToolHammer-top-6',
          'lumephons-idleHoldingToolHammer-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolPickaxe',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolPickaxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolPickaxe-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolPickaxe.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolPickaxe-bottom': [
          'lumephons-idleHoldingToolPickaxe-bottom-0',
          'lumephons-idleHoldingToolPickaxe-bottom-1',
          'lumephons-idleHoldingToolPickaxe-bottom-2',
          'lumephons-idleHoldingToolPickaxe-bottom-3',
          'lumephons-idleHoldingToolPickaxe-bottom-4',
          'lumephons-idleHoldingToolPickaxe-bottom-5',
          'lumephons-idleHoldingToolPickaxe-bottom-6',
          'lumephons-idleHoldingToolPickaxe-bottom-7',
        ],
        'lumephons-idleHoldingToolPickaxe-bottom-left': [
          'lumephons-idleHoldingToolPickaxe-bottom-left-0',
          'lumephons-idleHoldingToolPickaxe-bottom-left-1',
          'lumephons-idleHoldingToolPickaxe-bottom-left-2',
          'lumephons-idleHoldingToolPickaxe-bottom-left-3',
          'lumephons-idleHoldingToolPickaxe-bottom-left-4',
          'lumephons-idleHoldingToolPickaxe-bottom-left-5',
          'lumephons-idleHoldingToolPickaxe-bottom-left-6',
          'lumephons-idleHoldingToolPickaxe-bottom-left-7',
        ],
        'lumephons-idleHoldingToolPickaxe-left': [
          'lumephons-idleHoldingToolPickaxe-left-0',
          'lumephons-idleHoldingToolPickaxe-left-1',
          'lumephons-idleHoldingToolPickaxe-left-2',
          'lumephons-idleHoldingToolPickaxe-left-3',
          'lumephons-idleHoldingToolPickaxe-left-4',
          'lumephons-idleHoldingToolPickaxe-left-5',
          'lumephons-idleHoldingToolPickaxe-left-6',
          'lumephons-idleHoldingToolPickaxe-left-7',
        ],
        'lumephons-idleHoldingToolPickaxe-top-left': [
          'lumephons-idleHoldingToolPickaxe-top-left-0',
          'lumephons-idleHoldingToolPickaxe-top-left-1',
          'lumephons-idleHoldingToolPickaxe-top-left-2',
          'lumephons-idleHoldingToolPickaxe-top-left-3',
          'lumephons-idleHoldingToolPickaxe-top-left-4',
          'lumephons-idleHoldingToolPickaxe-top-left-5',
          'lumephons-idleHoldingToolPickaxe-top-left-6',
          'lumephons-idleHoldingToolPickaxe-top-left-7',
        ],
        'lumephons-idleHoldingToolPickaxe-top': [
          'lumephons-idleHoldingToolPickaxe-top-0',
          'lumephons-idleHoldingToolPickaxe-top-1',
          'lumephons-idleHoldingToolPickaxe-top-2',
          'lumephons-idleHoldingToolPickaxe-top-3',
          'lumephons-idleHoldingToolPickaxe-top-4',
          'lumephons-idleHoldingToolPickaxe-top-5',
          'lumephons-idleHoldingToolPickaxe-top-6',
          'lumephons-idleHoldingToolPickaxe-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolShield',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolShield-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShield-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolShield.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolShield-bottom': [
          'lumephons-idleHoldingToolShield-bottom-0',
          'lumephons-idleHoldingToolShield-bottom-1',
          'lumephons-idleHoldingToolShield-bottom-2',
          'lumephons-idleHoldingToolShield-bottom-3',
          'lumephons-idleHoldingToolShield-bottom-4',
          'lumephons-idleHoldingToolShield-bottom-5',
          'lumephons-idleHoldingToolShield-bottom-6',
          'lumephons-idleHoldingToolShield-bottom-7',
        ],
        'lumephons-idleHoldingToolShield-bottom-left': [
          'lumephons-idleHoldingToolShield-bottom-left-0',
          'lumephons-idleHoldingToolShield-bottom-left-1',
          'lumephons-idleHoldingToolShield-bottom-left-2',
          'lumephons-idleHoldingToolShield-bottom-left-3',
          'lumephons-idleHoldingToolShield-bottom-left-4',
          'lumephons-idleHoldingToolShield-bottom-left-5',
          'lumephons-idleHoldingToolShield-bottom-left-6',
          'lumephons-idleHoldingToolShield-bottom-left-7',
        ],
        'lumephons-idleHoldingToolShield-left': [
          'lumephons-idleHoldingToolShield-left-0',
          'lumephons-idleHoldingToolShield-left-1',
          'lumephons-idleHoldingToolShield-left-2',
          'lumephons-idleHoldingToolShield-left-3',
          'lumephons-idleHoldingToolShield-left-4',
          'lumephons-idleHoldingToolShield-left-5',
          'lumephons-idleHoldingToolShield-left-6',
          'lumephons-idleHoldingToolShield-left-7',
        ],
        'lumephons-idleHoldingToolShield-top-left': [
          'lumephons-idleHoldingToolShield-top-left-0',
          'lumephons-idleHoldingToolShield-top-left-1',
          'lumephons-idleHoldingToolShield-top-left-2',
          'lumephons-idleHoldingToolShield-top-left-3',
          'lumephons-idleHoldingToolShield-top-left-4',
          'lumephons-idleHoldingToolShield-top-left-5',
          'lumephons-idleHoldingToolShield-top-left-6',
          'lumephons-idleHoldingToolShield-top-left-7',
        ],
        'lumephons-idleHoldingToolShield-top': [
          'lumephons-idleHoldingToolShield-top-0',
          'lumephons-idleHoldingToolShield-top-1',
          'lumephons-idleHoldingToolShield-top-2',
          'lumephons-idleHoldingToolShield-top-3',
          'lumephons-idleHoldingToolShield-top-4',
          'lumephons-idleHoldingToolShield-top-5',
          'lumephons-idleHoldingToolShield-top-6',
          'lumephons-idleHoldingToolShield-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolShowel',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolShowel-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolShowel.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolShowel-bottom': [
          'lumephons-idleHoldingToolShowel-bottom-0',
          'lumephons-idleHoldingToolShowel-bottom-1',
          'lumephons-idleHoldingToolShowel-bottom-2',
          'lumephons-idleHoldingToolShowel-bottom-3',
          'lumephons-idleHoldingToolShowel-bottom-4',
          'lumephons-idleHoldingToolShowel-bottom-5',
          'lumephons-idleHoldingToolShowel-bottom-6',
          'lumephons-idleHoldingToolShowel-bottom-7',
        ],
        'lumephons-idleHoldingToolShowel-bottom-left': [
          'lumephons-idleHoldingToolShowel-bottom-left-0',
          'lumephons-idleHoldingToolShowel-bottom-left-1',
          'lumephons-idleHoldingToolShowel-bottom-left-2',
          'lumephons-idleHoldingToolShowel-bottom-left-3',
          'lumephons-idleHoldingToolShowel-bottom-left-4',
          'lumephons-idleHoldingToolShowel-bottom-left-5',
          'lumephons-idleHoldingToolShowel-bottom-left-6',
          'lumephons-idleHoldingToolShowel-bottom-left-7',
        ],
        'lumephons-idleHoldingToolShowel-left': [
          'lumephons-idleHoldingToolShowel-left-0',
          'lumephons-idleHoldingToolShowel-left-1',
          'lumephons-idleHoldingToolShowel-left-2',
          'lumephons-idleHoldingToolShowel-left-3',
          'lumephons-idleHoldingToolShowel-left-4',
          'lumephons-idleHoldingToolShowel-left-5',
          'lumephons-idleHoldingToolShowel-left-6',
          'lumephons-idleHoldingToolShowel-left-7',
        ],
        'lumephons-idleHoldingToolShowel-top-left': [
          'lumephons-idleHoldingToolShowel-top-left-0',
          'lumephons-idleHoldingToolShowel-top-left-1',
          'lumephons-idleHoldingToolShowel-top-left-2',
          'lumephons-idleHoldingToolShowel-top-left-3',
          'lumephons-idleHoldingToolShowel-top-left-4',
          'lumephons-idleHoldingToolShowel-top-left-5',
          'lumephons-idleHoldingToolShowel-top-left-6',
          'lumephons-idleHoldingToolShowel-top-left-7',
        ],
        'lumephons-idleHoldingToolShowel-top': [
          'lumephons-idleHoldingToolShowel-top-0',
          'lumephons-idleHoldingToolShowel-top-1',
          'lumephons-idleHoldingToolShowel-top-2',
          'lumephons-idleHoldingToolShowel-top-3',
          'lumephons-idleHoldingToolShowel-top-4',
          'lumephons-idleHoldingToolShowel-top-5',
          'lumephons-idleHoldingToolShowel-top-6',
          'lumephons-idleHoldingToolShowel-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolSword',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolSword-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolSword.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolSword-bottom': [
          'lumephons-idleHoldingToolSword-bottom-0',
          'lumephons-idleHoldingToolSword-bottom-1',
          'lumephons-idleHoldingToolSword-bottom-2',
          'lumephons-idleHoldingToolSword-bottom-3',
          'lumephons-idleHoldingToolSword-bottom-4',
          'lumephons-idleHoldingToolSword-bottom-5',
          'lumephons-idleHoldingToolSword-bottom-6',
          'lumephons-idleHoldingToolSword-bottom-7',
        ],
        'lumephons-idleHoldingToolSword-bottom-left': [
          'lumephons-idleHoldingToolSword-bottom-left-0',
          'lumephons-idleHoldingToolSword-bottom-left-1',
          'lumephons-idleHoldingToolSword-bottom-left-2',
          'lumephons-idleHoldingToolSword-bottom-left-3',
          'lumephons-idleHoldingToolSword-bottom-left-4',
          'lumephons-idleHoldingToolSword-bottom-left-5',
          'lumephons-idleHoldingToolSword-bottom-left-6',
          'lumephons-idleHoldingToolSword-bottom-left-7',
        ],
        'lumephons-idleHoldingToolSword-left': [
          'lumephons-idleHoldingToolSword-left-0',
          'lumephons-idleHoldingToolSword-left-1',
          'lumephons-idleHoldingToolSword-left-2',
          'lumephons-idleHoldingToolSword-left-3',
          'lumephons-idleHoldingToolSword-left-4',
          'lumephons-idleHoldingToolSword-left-5',
          'lumephons-idleHoldingToolSword-left-6',
          'lumephons-idleHoldingToolSword-left-7',
        ],
        'lumephons-idleHoldingToolSword-top-left': [
          'lumephons-idleHoldingToolSword-top-left-0',
          'lumephons-idleHoldingToolSword-top-left-1',
          'lumephons-idleHoldingToolSword-top-left-2',
          'lumephons-idleHoldingToolSword-top-left-3',
          'lumephons-idleHoldingToolSword-top-left-4',
          'lumephons-idleHoldingToolSword-top-left-5',
          'lumephons-idleHoldingToolSword-top-left-6',
          'lumephons-idleHoldingToolSword-top-left-7',
        ],
        'lumephons-idleHoldingToolSword-top': [
          'lumephons-idleHoldingToolSword-top-0',
          'lumephons-idleHoldingToolSword-top-1',
          'lumephons-idleHoldingToolSword-top-2',
          'lumephons-idleHoldingToolSword-top-3',
          'lumephons-idleHoldingToolSword-top-4',
          'lumephons-idleHoldingToolSword-top-5',
          'lumephons-idleHoldingToolSword-top-6',
          'lumephons-idleHoldingToolSword-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-idleHoldingToolWaterCan',
    metadata: {
      frames: {
        'lumephons-idleHoldingToolWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-6': {
          frame: {
            x: 2760,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-7': {
          frame: {
            x: 3220,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-6': {
          frame: {
            x: 2760,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-bottom-left-7': {
          frame: {
            x: 3220,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-6': {
          frame: {
            x: 2760,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-left-7': {
          frame: {
            x: 3220,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-6': {
          frame: {
            x: 2760,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-left-7': {
          frame: {
            x: 3220,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-6': {
          frame: {
            x: 2760,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-idleHoldingToolWaterCan-top-7': {
          frame: {
            x: 3220,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/idleHoldingToolWaterCan.png',
        size: {
          w: 3680,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-idleHoldingToolWaterCan-bottom': [
          'lumephons-idleHoldingToolWaterCan-bottom-0',
          'lumephons-idleHoldingToolWaterCan-bottom-1',
          'lumephons-idleHoldingToolWaterCan-bottom-2',
          'lumephons-idleHoldingToolWaterCan-bottom-3',
          'lumephons-idleHoldingToolWaterCan-bottom-4',
          'lumephons-idleHoldingToolWaterCan-bottom-5',
          'lumephons-idleHoldingToolWaterCan-bottom-6',
          'lumephons-idleHoldingToolWaterCan-bottom-7',
        ],
        'lumephons-idleHoldingToolWaterCan-bottom-left': [
          'lumephons-idleHoldingToolWaterCan-bottom-left-0',
          'lumephons-idleHoldingToolWaterCan-bottom-left-1',
          'lumephons-idleHoldingToolWaterCan-bottom-left-2',
          'lumephons-idleHoldingToolWaterCan-bottom-left-3',
          'lumephons-idleHoldingToolWaterCan-bottom-left-4',
          'lumephons-idleHoldingToolWaterCan-bottom-left-5',
          'lumephons-idleHoldingToolWaterCan-bottom-left-6',
          'lumephons-idleHoldingToolWaterCan-bottom-left-7',
        ],
        'lumephons-idleHoldingToolWaterCan-left': [
          'lumephons-idleHoldingToolWaterCan-left-0',
          'lumephons-idleHoldingToolWaterCan-left-1',
          'lumephons-idleHoldingToolWaterCan-left-2',
          'lumephons-idleHoldingToolWaterCan-left-3',
          'lumephons-idleHoldingToolWaterCan-left-4',
          'lumephons-idleHoldingToolWaterCan-left-5',
          'lumephons-idleHoldingToolWaterCan-left-6',
          'lumephons-idleHoldingToolWaterCan-left-7',
        ],
        'lumephons-idleHoldingToolWaterCan-top-left': [
          'lumephons-idleHoldingToolWaterCan-top-left-0',
          'lumephons-idleHoldingToolWaterCan-top-left-1',
          'lumephons-idleHoldingToolWaterCan-top-left-2',
          'lumephons-idleHoldingToolWaterCan-top-left-3',
          'lumephons-idleHoldingToolWaterCan-top-left-4',
          'lumephons-idleHoldingToolWaterCan-top-left-5',
          'lumephons-idleHoldingToolWaterCan-top-left-6',
          'lumephons-idleHoldingToolWaterCan-top-left-7',
        ],
        'lumephons-idleHoldingToolWaterCan-top': [
          'lumephons-idleHoldingToolWaterCan-top-0',
          'lumephons-idleHoldingToolWaterCan-top-1',
          'lumephons-idleHoldingToolWaterCan-top-2',
          'lumephons-idleHoldingToolWaterCan-top-3',
          'lumephons-idleHoldingToolWaterCan-top-4',
          'lumephons-idleHoldingToolWaterCan-top-5',
          'lumephons-idleHoldingToolWaterCan-top-6',
          'lumephons-idleHoldingToolWaterCan-top-7',
        ],
      },
    },
  },
  {
    name: 'lumephons-interact',
    metadata: {
      frames: {
        'lumephons-interact-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interact-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interact.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interact-bottom': [
          'lumephons-interact-bottom-0',
          'lumephons-interact-bottom-1',
          'lumephons-interact-bottom-2',
        ],
        'lumephons-interact-bottom-left': [
          'lumephons-interact-bottom-left-0',
          'lumephons-interact-bottom-left-1',
          'lumephons-interact-bottom-left-2',
        ],
        'lumephons-interact-left': [
          'lumephons-interact-left-0',
          'lumephons-interact-left-1',
          'lumephons-interact-left-2',
        ],
        'lumephons-interact-top-left': [
          'lumephons-interact-top-left-0',
          'lumephons-interact-top-left-1',
          'lumephons-interact-top-left-2',
        ],
        'lumephons-interact-top': [
          'lumephons-interact-top-0',
          'lumephons-interact-top-1',
          'lumephons-interact-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingTool',
    metadata: {
      frames: {
        'lumephons-interactHoldingTool-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingTool-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingTool.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingTool-bottom': [
          'lumephons-interactHoldingTool-bottom-0',
          'lumephons-interactHoldingTool-bottom-1',
          'lumephons-interactHoldingTool-bottom-2',
        ],
        'lumephons-interactHoldingTool-bottom-left': [
          'lumephons-interactHoldingTool-bottom-left-0',
          'lumephons-interactHoldingTool-bottom-left-1',
          'lumephons-interactHoldingTool-bottom-left-2',
        ],
        'lumephons-interactHoldingTool-left': [
          'lumephons-interactHoldingTool-left-0',
          'lumephons-interactHoldingTool-left-1',
          'lumephons-interactHoldingTool-left-2',
        ],
        'lumephons-interactHoldingTool-top-left': [
          'lumephons-interactHoldingTool-top-left-0',
          'lumephons-interactHoldingTool-top-left-1',
          'lumephons-interactHoldingTool-top-left-2',
        ],
        'lumephons-interactHoldingTool-top': [
          'lumephons-interactHoldingTool-top-0',
          'lumephons-interactHoldingTool-top-1',
          'lumephons-interactHoldingTool-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolAxe',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolAxe.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolAxe-bottom': [
          'lumephons-interactHoldingToolAxe-bottom-0',
          'lumephons-interactHoldingToolAxe-bottom-1',
          'lumephons-interactHoldingToolAxe-bottom-2',
        ],
        'lumephons-interactHoldingToolAxe-bottom-left': [
          'lumephons-interactHoldingToolAxe-bottom-left-0',
          'lumephons-interactHoldingToolAxe-bottom-left-1',
          'lumephons-interactHoldingToolAxe-bottom-left-2',
        ],
        'lumephons-interactHoldingToolAxe-left': [
          'lumephons-interactHoldingToolAxe-left-0',
          'lumephons-interactHoldingToolAxe-left-1',
          'lumephons-interactHoldingToolAxe-left-2',
        ],
        'lumephons-interactHoldingToolAxe-top-left': [
          'lumephons-interactHoldingToolAxe-top-left-0',
          'lumephons-interactHoldingToolAxe-top-left-1',
          'lumephons-interactHoldingToolAxe-top-left-2',
        ],
        'lumephons-interactHoldingToolAxe-top': [
          'lumephons-interactHoldingToolAxe-top-0',
          'lumephons-interactHoldingToolAxe-top-1',
          'lumephons-interactHoldingToolAxe-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolFishingpole',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolFishingpole.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolFishingpole-bottom': [
          'lumephons-interactHoldingToolFishingpole-bottom-0',
          'lumephons-interactHoldingToolFishingpole-bottom-1',
          'lumephons-interactHoldingToolFishingpole-bottom-2',
        ],
        'lumephons-interactHoldingToolFishingpole-bottom-left': [
          'lumephons-interactHoldingToolFishingpole-bottom-left-0',
          'lumephons-interactHoldingToolFishingpole-bottom-left-1',
          'lumephons-interactHoldingToolFishingpole-bottom-left-2',
        ],
        'lumephons-interactHoldingToolFishingpole-left': [
          'lumephons-interactHoldingToolFishingpole-left-0',
          'lumephons-interactHoldingToolFishingpole-left-1',
          'lumephons-interactHoldingToolFishingpole-left-2',
        ],
        'lumephons-interactHoldingToolFishingpole-top-left': [
          'lumephons-interactHoldingToolFishingpole-top-left-0',
          'lumephons-interactHoldingToolFishingpole-top-left-1',
          'lumephons-interactHoldingToolFishingpole-top-left-2',
        ],
        'lumephons-interactHoldingToolFishingpole-top': [
          'lumephons-interactHoldingToolFishingpole-top-0',
          'lumephons-interactHoldingToolFishingpole-top-1',
          'lumephons-interactHoldingToolFishingpole-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolHammer',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolHammer.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolHammer-bottom': [
          'lumephons-interactHoldingToolHammer-bottom-0',
          'lumephons-interactHoldingToolHammer-bottom-1',
          'lumephons-interactHoldingToolHammer-bottom-2',
        ],
        'lumephons-interactHoldingToolHammer-bottom-left': [
          'lumephons-interactHoldingToolHammer-bottom-left-0',
          'lumephons-interactHoldingToolHammer-bottom-left-1',
          'lumephons-interactHoldingToolHammer-bottom-left-2',
        ],
        'lumephons-interactHoldingToolHammer-left': [
          'lumephons-interactHoldingToolHammer-left-0',
          'lumephons-interactHoldingToolHammer-left-1',
          'lumephons-interactHoldingToolHammer-left-2',
        ],
        'lumephons-interactHoldingToolHammer-top-left': [
          'lumephons-interactHoldingToolHammer-top-left-0',
          'lumephons-interactHoldingToolHammer-top-left-1',
          'lumephons-interactHoldingToolHammer-top-left-2',
        ],
        'lumephons-interactHoldingToolHammer-top': [
          'lumephons-interactHoldingToolHammer-top-0',
          'lumephons-interactHoldingToolHammer-top-1',
          'lumephons-interactHoldingToolHammer-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolPickAxe',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolPickAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolPickAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolPickAxe.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolPickAxe-bottom': [
          'lumephons-interactHoldingToolPickAxe-bottom-0',
          'lumephons-interactHoldingToolPickAxe-bottom-1',
          'lumephons-interactHoldingToolPickAxe-bottom-2',
        ],
        'lumephons-interactHoldingToolPickAxe-bottom-left': [
          'lumephons-interactHoldingToolPickAxe-bottom-left-0',
          'lumephons-interactHoldingToolPickAxe-bottom-left-1',
          'lumephons-interactHoldingToolPickAxe-bottom-left-2',
        ],
        'lumephons-interactHoldingToolPickAxe-left': [
          'lumephons-interactHoldingToolPickAxe-left-0',
          'lumephons-interactHoldingToolPickAxe-left-1',
          'lumephons-interactHoldingToolPickAxe-left-2',
        ],
        'lumephons-interactHoldingToolPickAxe-top-left': [
          'lumephons-interactHoldingToolPickAxe-top-left-0',
          'lumephons-interactHoldingToolPickAxe-top-left-1',
          'lumephons-interactHoldingToolPickAxe-top-left-2',
        ],
        'lumephons-interactHoldingToolPickAxe-top': [
          'lumephons-interactHoldingToolPickAxe-top-0',
          'lumephons-interactHoldingToolPickAxe-top-1',
          'lumephons-interactHoldingToolPickAxe-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolShield',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolShield-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShield-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolShield.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolShield-bottom': [
          'lumephons-interactHoldingToolShield-bottom-0',
          'lumephons-interactHoldingToolShield-bottom-1',
          'lumephons-interactHoldingToolShield-bottom-2',
        ],
        'lumephons-interactHoldingToolShield-bottom-left': [
          'lumephons-interactHoldingToolShield-bottom-left-0',
          'lumephons-interactHoldingToolShield-bottom-left-1',
          'lumephons-interactHoldingToolShield-bottom-left-2',
        ],
        'lumephons-interactHoldingToolShield-left': [
          'lumephons-interactHoldingToolShield-left-0',
          'lumephons-interactHoldingToolShield-left-1',
          'lumephons-interactHoldingToolShield-left-2',
        ],
        'lumephons-interactHoldingToolShield-top-left': [
          'lumephons-interactHoldingToolShield-top-left-0',
          'lumephons-interactHoldingToolShield-top-left-1',
          'lumephons-interactHoldingToolShield-top-left-2',
        ],
        'lumephons-interactHoldingToolShield-top': [
          'lumephons-interactHoldingToolShield-top-0',
          'lumephons-interactHoldingToolShield-top-1',
          'lumephons-interactHoldingToolShield-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolShowel',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolShowel-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolShowel.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolShowel-bottom': [
          'lumephons-interactHoldingToolShowel-bottom-0',
          'lumephons-interactHoldingToolShowel-bottom-1',
          'lumephons-interactHoldingToolShowel-bottom-2',
        ],
        'lumephons-interactHoldingToolShowel-bottom-left': [
          'lumephons-interactHoldingToolShowel-bottom-left-0',
          'lumephons-interactHoldingToolShowel-bottom-left-1',
          'lumephons-interactHoldingToolShowel-bottom-left-2',
        ],
        'lumephons-interactHoldingToolShowel-left': [
          'lumephons-interactHoldingToolShowel-left-0',
          'lumephons-interactHoldingToolShowel-left-1',
          'lumephons-interactHoldingToolShowel-left-2',
        ],
        'lumephons-interactHoldingToolShowel-top-left': [
          'lumephons-interactHoldingToolShowel-top-left-0',
          'lumephons-interactHoldingToolShowel-top-left-1',
          'lumephons-interactHoldingToolShowel-top-left-2',
        ],
        'lumephons-interactHoldingToolShowel-top': [
          'lumephons-interactHoldingToolShowel-top-0',
          'lumephons-interactHoldingToolShowel-top-1',
          'lumephons-interactHoldingToolShowel-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolSword',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolSword.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolSword-bottom': [
          'lumephons-interactHoldingToolSword-bottom-0',
          'lumephons-interactHoldingToolSword-bottom-1',
          'lumephons-interactHoldingToolSword-bottom-2',
        ],
        'lumephons-interactHoldingToolSword-bottom-left': [
          'lumephons-interactHoldingToolSword-bottom-left-0',
          'lumephons-interactHoldingToolSword-bottom-left-1',
          'lumephons-interactHoldingToolSword-bottom-left-2',
        ],
        'lumephons-interactHoldingToolSword-left': [
          'lumephons-interactHoldingToolSword-left-0',
          'lumephons-interactHoldingToolSword-left-1',
          'lumephons-interactHoldingToolSword-left-2',
        ],
        'lumephons-interactHoldingToolSword-top-left': [
          'lumephons-interactHoldingToolSword-top-left-0',
          'lumephons-interactHoldingToolSword-top-left-1',
          'lumephons-interactHoldingToolSword-top-left-2',
        ],
        'lumephons-interactHoldingToolSword-top': [
          'lumephons-interactHoldingToolSword-top-0',
          'lumephons-interactHoldingToolSword-top-1',
          'lumephons-interactHoldingToolSword-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-interactHoldingToolWaterCan',
    metadata: {
      frames: {
        'lumephons-interactHoldingToolWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-interactHoldingToolWaterCan-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/interactHoldingToolWaterCan.png',
        size: {
          w: 1380,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-interactHoldingToolWaterCan-bottom': [
          'lumephons-interactHoldingToolWaterCan-bottom-0',
          'lumephons-interactHoldingToolWaterCan-bottom-1',
          'lumephons-interactHoldingToolWaterCan-bottom-2',
        ],
        'lumephons-interactHoldingToolWaterCan-bottom-left': [
          'lumephons-interactHoldingToolWaterCan-bottom-left-0',
          'lumephons-interactHoldingToolWaterCan-bottom-left-1',
          'lumephons-interactHoldingToolWaterCan-bottom-left-2',
        ],
        'lumephons-interactHoldingToolWaterCan-left': [
          'lumephons-interactHoldingToolWaterCan-left-0',
          'lumephons-interactHoldingToolWaterCan-left-1',
          'lumephons-interactHoldingToolWaterCan-left-2',
        ],
        'lumephons-interactHoldingToolWaterCan-top-left': [
          'lumephons-interactHoldingToolWaterCan-top-left-0',
          'lumephons-interactHoldingToolWaterCan-top-left-1',
          'lumephons-interactHoldingToolWaterCan-top-left-2',
        ],
        'lumephons-interactHoldingToolWaterCan-top': [
          'lumephons-interactHoldingToolWaterCan-top-0',
          'lumephons-interactHoldingToolWaterCan-top-1',
          'lumephons-interactHoldingToolWaterCan-top-2',
        ],
      },
    },
  },
  {
    name: 'lumephons-run',
    metadata: {
      frames: {
        'lumephons-run-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-run-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/run.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-run-bottom': [
          'lumephons-run-bottom-0',
          'lumephons-run-bottom-1',
          'lumephons-run-bottom-2',
          'lumephons-run-bottom-3',
        ],
        'lumephons-run-bottom-left': [
          'lumephons-run-bottom-left-0',
          'lumephons-run-bottom-left-1',
          'lumephons-run-bottom-left-2',
          'lumephons-run-bottom-left-3',
        ],
        'lumephons-run-left': [
          'lumephons-run-left-0',
          'lumephons-run-left-1',
          'lumephons-run-left-2',
          'lumephons-run-left-3',
        ],
        'lumephons-run-top-left': [
          'lumephons-run-top-left-0',
          'lumephons-run-top-left-1',
          'lumephons-run-top-left-2',
          'lumephons-run-top-left-3',
        ],
        'lumephons-run-top': [
          'lumephons-run-top-0',
          'lumephons-run-top-1',
          'lumephons-run-top-2',
          'lumephons-run-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runAxe',
    metadata: {
      frames: {
        'lumephons-runAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runAxe.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runAxe-bottom': [
          'lumephons-runAxe-bottom-0',
          'lumephons-runAxe-bottom-1',
          'lumephons-runAxe-bottom-2',
          'lumephons-runAxe-bottom-3',
        ],
        'lumephons-runAxe-bottom-left': [
          'lumephons-runAxe-bottom-left-0',
          'lumephons-runAxe-bottom-left-1',
          'lumephons-runAxe-bottom-left-2',
          'lumephons-runAxe-bottom-left-3',
        ],
        'lumephons-runAxe-left': [
          'lumephons-runAxe-left-0',
          'lumephons-runAxe-left-1',
          'lumephons-runAxe-left-2',
          'lumephons-runAxe-left-3',
        ],
        'lumephons-runAxe-top-left': [
          'lumephons-runAxe-top-left-0',
          'lumephons-runAxe-top-left-1',
          'lumephons-runAxe-top-left-2',
          'lumephons-runAxe-top-left-3',
        ],
        'lumephons-runAxe-top': [
          'lumephons-runAxe-top-0',
          'lumephons-runAxe-top-1',
          'lumephons-runAxe-top-2',
          'lumephons-runAxe-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runFishingpole',
    metadata: {
      frames: {
        'lumephons-runFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runFishingpole-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runFishingpole.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runFishingpole-bottom': [
          'lumephons-runFishingpole-bottom-0',
          'lumephons-runFishingpole-bottom-1',
          'lumephons-runFishingpole-bottom-2',
          'lumephons-runFishingpole-bottom-3',
        ],
        'lumephons-runFishingpole-bottom-left': [
          'lumephons-runFishingpole-bottom-left-0',
          'lumephons-runFishingpole-bottom-left-1',
          'lumephons-runFishingpole-bottom-left-2',
          'lumephons-runFishingpole-bottom-left-3',
        ],
        'lumephons-runFishingpole-left': [
          'lumephons-runFishingpole-left-0',
          'lumephons-runFishingpole-left-1',
          'lumephons-runFishingpole-left-2',
          'lumephons-runFishingpole-left-3',
        ],
        'lumephons-runFishingpole-top-left': [
          'lumephons-runFishingpole-top-left-0',
          'lumephons-runFishingpole-top-left-1',
          'lumephons-runFishingpole-top-left-2',
          'lumephons-runFishingpole-top-left-3',
        ],
        'lumephons-runFishingpole-top': [
          'lumephons-runFishingpole-top-0',
          'lumephons-runFishingpole-top-1',
          'lumephons-runFishingpole-top-2',
          'lumephons-runFishingpole-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runHammer',
    metadata: {
      frames: {
        'lumephons-runHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runHammer-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runHammer.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runHammer-bottom': [
          'lumephons-runHammer-bottom-0',
          'lumephons-runHammer-bottom-1',
          'lumephons-runHammer-bottom-2',
          'lumephons-runHammer-bottom-3',
        ],
        'lumephons-runHammer-bottom-left': [
          'lumephons-runHammer-bottom-left-0',
          'lumephons-runHammer-bottom-left-1',
          'lumephons-runHammer-bottom-left-2',
          'lumephons-runHammer-bottom-left-3',
        ],
        'lumephons-runHammer-left': [
          'lumephons-runHammer-left-0',
          'lumephons-runHammer-left-1',
          'lumephons-runHammer-left-2',
          'lumephons-runHammer-left-3',
        ],
        'lumephons-runHammer-top-left': [
          'lumephons-runHammer-top-left-0',
          'lumephons-runHammer-top-left-1',
          'lumephons-runHammer-top-left-2',
          'lumephons-runHammer-top-left-3',
        ],
        'lumephons-runHammer-top': [
          'lumephons-runHammer-top-0',
          'lumephons-runHammer-top-1',
          'lumephons-runHammer-top-2',
          'lumephons-runHammer-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runPickAxe',
    metadata: {
      frames: {
        'lumephons-runPickAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runPickAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runPickAxe.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runPickAxe-bottom': [
          'lumephons-runPickAxe-bottom-0',
          'lumephons-runPickAxe-bottom-1',
          'lumephons-runPickAxe-bottom-2',
          'lumephons-runPickAxe-bottom-3',
        ],
        'lumephons-runPickAxe-bottom-left': [
          'lumephons-runPickAxe-bottom-left-0',
          'lumephons-runPickAxe-bottom-left-1',
          'lumephons-runPickAxe-bottom-left-2',
          'lumephons-runPickAxe-bottom-left-3',
        ],
        'lumephons-runPickAxe-left': [
          'lumephons-runPickAxe-left-0',
          'lumephons-runPickAxe-left-1',
          'lumephons-runPickAxe-left-2',
          'lumephons-runPickAxe-left-3',
        ],
        'lumephons-runPickAxe-top-left': [
          'lumephons-runPickAxe-top-left-0',
          'lumephons-runPickAxe-top-left-1',
          'lumephons-runPickAxe-top-left-2',
          'lumephons-runPickAxe-top-left-3',
        ],
        'lumephons-runPickAxe-top': [
          'lumephons-runPickAxe-top-0',
          'lumephons-runPickAxe-top-1',
          'lumephons-runPickAxe-top-2',
          'lumephons-runPickAxe-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runShield',
    metadata: {
      frames: {
        'lumephons-runShield-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runShield-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runShield.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runShield-bottom': [
          'lumephons-runShield-bottom-0',
          'lumephons-runShield-bottom-1',
          'lumephons-runShield-bottom-2',
          'lumephons-runShield-bottom-3',
        ],
        'lumephons-runShield-bottom-left': [
          'lumephons-runShield-bottom-left-0',
          'lumephons-runShield-bottom-left-1',
          'lumephons-runShield-bottom-left-2',
          'lumephons-runShield-bottom-left-3',
        ],
        'lumephons-runShield-left': [
          'lumephons-runShield-left-0',
          'lumephons-runShield-left-1',
          'lumephons-runShield-left-2',
          'lumephons-runShield-left-3',
        ],
        'lumephons-runShield-top-left': [
          'lumephons-runShield-top-left-0',
          'lumephons-runShield-top-left-1',
          'lumephons-runShield-top-left-2',
          'lumephons-runShield-top-left-3',
        ],
        'lumephons-runShield-top': [
          'lumephons-runShield-top-0',
          'lumephons-runShield-top-1',
          'lumephons-runShield-top-2',
          'lumephons-runShield-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runSword',
    metadata: {
      frames: {
        'lumephons-runSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runSword-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runSword.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runSword-bottom': [
          'lumephons-runSword-bottom-0',
          'lumephons-runSword-bottom-1',
          'lumephons-runSword-bottom-2',
          'lumephons-runSword-bottom-3',
        ],
        'lumephons-runSword-bottom-left': [
          'lumephons-runSword-bottom-left-0',
          'lumephons-runSword-bottom-left-1',
          'lumephons-runSword-bottom-left-2',
          'lumephons-runSword-bottom-left-3',
        ],
        'lumephons-runSword-left': [
          'lumephons-runSword-left-0',
          'lumephons-runSword-left-1',
          'lumephons-runSword-left-2',
          'lumephons-runSword-left-3',
        ],
        'lumephons-runSword-top-left': [
          'lumephons-runSword-top-left-0',
          'lumephons-runSword-top-left-1',
          'lumephons-runSword-top-left-2',
          'lumephons-runSword-top-left-3',
        ],
        'lumephons-runSword-top': [
          'lumephons-runSword-top-0',
          'lumephons-runSword-top-1',
          'lumephons-runSword-top-2',
          'lumephons-runSword-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-runWaterCan',
    metadata: {
      frames: {
        'lumephons-runWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-runWaterCan-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/runWaterCan.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-runWaterCan-bottom': [
          'lumephons-runWaterCan-bottom-0',
          'lumephons-runWaterCan-bottom-1',
          'lumephons-runWaterCan-bottom-2',
          'lumephons-runWaterCan-bottom-3',
        ],
        'lumephons-runWaterCan-bottom-left': [
          'lumephons-runWaterCan-bottom-left-0',
          'lumephons-runWaterCan-bottom-left-1',
          'lumephons-runWaterCan-bottom-left-2',
          'lumephons-runWaterCan-bottom-left-3',
        ],
        'lumephons-runWaterCan-left': [
          'lumephons-runWaterCan-left-0',
          'lumephons-runWaterCan-left-1',
          'lumephons-runWaterCan-left-2',
          'lumephons-runWaterCan-left-3',
        ],
        'lumephons-runWaterCan-top-left': [
          'lumephons-runWaterCan-top-left-0',
          'lumephons-runWaterCan-top-left-1',
          'lumephons-runWaterCan-top-left-2',
          'lumephons-runWaterCan-top-left-3',
        ],
        'lumephons-runWaterCan-top': [
          'lumephons-runWaterCan-top-0',
          'lumephons-runWaterCan-top-1',
          'lumephons-runWaterCan-top-2',
          'lumephons-runWaterCan-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sit',
    metadata: {
      frames: {
        'lumephons-sit-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sit-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sit.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sit-bottom': [
          'lumephons-sit-bottom-0',
          'lumephons-sit-bottom-1',
          'lumephons-sit-bottom-2',
          'lumephons-sit-bottom-3',
        ],
        'lumephons-sit-bottom-left': [
          'lumephons-sit-bottom-left-0',
          'lumephons-sit-bottom-left-1',
          'lumephons-sit-bottom-left-2',
          'lumephons-sit-bottom-left-3',
        ],
        'lumephons-sit-left': [
          'lumephons-sit-left-0',
          'lumephons-sit-left-1',
          'lumephons-sit-left-2',
          'lumephons-sit-left-3',
        ],
        'lumephons-sit-top-left': [
          'lumephons-sit-top-left-0',
          'lumephons-sit-top-left-1',
          'lumephons-sit-top-left-2',
          'lumephons-sit-top-left-3',
        ],
        'lumephons-sit-top': [
          'lumephons-sit-top-0',
          'lumephons-sit-top-1',
          'lumephons-sit-top-2',
          'lumephons-sit-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingTool',
    metadata: {
      frames: {
        'lumephons-sitHoldingTool-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingTool-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingTool.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingTool-bottom': [
          'lumephons-sitHoldingTool-bottom-0',
          'lumephons-sitHoldingTool-bottom-1',
          'lumephons-sitHoldingTool-bottom-2',
          'lumephons-sitHoldingTool-bottom-3',
        ],
        'lumephons-sitHoldingTool-bottom-left': [
          'lumephons-sitHoldingTool-bottom-left-0',
          'lumephons-sitHoldingTool-bottom-left-1',
          'lumephons-sitHoldingTool-bottom-left-2',
          'lumephons-sitHoldingTool-bottom-left-3',
        ],
        'lumephons-sitHoldingTool-left': [
          'lumephons-sitHoldingTool-left-0',
          'lumephons-sitHoldingTool-left-1',
          'lumephons-sitHoldingTool-left-2',
          'lumephons-sitHoldingTool-left-3',
        ],
        'lumephons-sitHoldingTool-top-left': [
          'lumephons-sitHoldingTool-top-left-0',
          'lumephons-sitHoldingTool-top-left-1',
          'lumephons-sitHoldingTool-top-left-2',
          'lumephons-sitHoldingTool-top-left-3',
        ],
        'lumephons-sitHoldingTool-top': [
          'lumephons-sitHoldingTool-top-0',
          'lumephons-sitHoldingTool-top-1',
          'lumephons-sitHoldingTool-top-2',
          'lumephons-sitHoldingTool-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolAxe',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolAxe.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolAxe-bottom': [
          'lumephons-sitHoldingToolAxe-bottom-0',
          'lumephons-sitHoldingToolAxe-bottom-1',
          'lumephons-sitHoldingToolAxe-bottom-2',
          'lumephons-sitHoldingToolAxe-bottom-3',
        ],
        'lumephons-sitHoldingToolAxe-bottom-left': [
          'lumephons-sitHoldingToolAxe-bottom-left-0',
          'lumephons-sitHoldingToolAxe-bottom-left-1',
          'lumephons-sitHoldingToolAxe-bottom-left-2',
          'lumephons-sitHoldingToolAxe-bottom-left-3',
        ],
        'lumephons-sitHoldingToolAxe-left': [
          'lumephons-sitHoldingToolAxe-left-0',
          'lumephons-sitHoldingToolAxe-left-1',
          'lumephons-sitHoldingToolAxe-left-2',
          'lumephons-sitHoldingToolAxe-left-3',
        ],
        'lumephons-sitHoldingToolAxe-top-left': [
          'lumephons-sitHoldingToolAxe-top-left-0',
          'lumephons-sitHoldingToolAxe-top-left-1',
          'lumephons-sitHoldingToolAxe-top-left-2',
          'lumephons-sitHoldingToolAxe-top-left-3',
        ],
        'lumephons-sitHoldingToolAxe-top': [
          'lumephons-sitHoldingToolAxe-top-0',
          'lumephons-sitHoldingToolAxe-top-1',
          'lumephons-sitHoldingToolAxe-top-2',
          'lumephons-sitHoldingToolAxe-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolFishingpole',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolFishingpole-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolFishingpole.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolFishingpole-bottom': [
          'lumephons-sitHoldingToolFishingpole-bottom-0',
          'lumephons-sitHoldingToolFishingpole-bottom-1',
          'lumephons-sitHoldingToolFishingpole-bottom-2',
          'lumephons-sitHoldingToolFishingpole-bottom-3',
        ],
        'lumephons-sitHoldingToolFishingpole-bottom-left': [
          'lumephons-sitHoldingToolFishingpole-bottom-left-0',
          'lumephons-sitHoldingToolFishingpole-bottom-left-1',
          'lumephons-sitHoldingToolFishingpole-bottom-left-2',
          'lumephons-sitHoldingToolFishingpole-bottom-left-3',
        ],
        'lumephons-sitHoldingToolFishingpole-left': [
          'lumephons-sitHoldingToolFishingpole-left-0',
          'lumephons-sitHoldingToolFishingpole-left-1',
          'lumephons-sitHoldingToolFishingpole-left-2',
          'lumephons-sitHoldingToolFishingpole-left-3',
        ],
        'lumephons-sitHoldingToolFishingpole-top-left': [
          'lumephons-sitHoldingToolFishingpole-top-left-0',
          'lumephons-sitHoldingToolFishingpole-top-left-1',
          'lumephons-sitHoldingToolFishingpole-top-left-2',
          'lumephons-sitHoldingToolFishingpole-top-left-3',
        ],
        'lumephons-sitHoldingToolFishingpole-top': [
          'lumephons-sitHoldingToolFishingpole-top-0',
          'lumephons-sitHoldingToolFishingpole-top-1',
          'lumephons-sitHoldingToolFishingpole-top-2',
          'lumephons-sitHoldingToolFishingpole-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolHammer',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolHammer-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolHammer.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolHammer-bottom': [
          'lumephons-sitHoldingToolHammer-bottom-0',
          'lumephons-sitHoldingToolHammer-bottom-1',
          'lumephons-sitHoldingToolHammer-bottom-2',
          'lumephons-sitHoldingToolHammer-bottom-3',
        ],
        'lumephons-sitHoldingToolHammer-bottom-left': [
          'lumephons-sitHoldingToolHammer-bottom-left-0',
          'lumephons-sitHoldingToolHammer-bottom-left-1',
          'lumephons-sitHoldingToolHammer-bottom-left-2',
          'lumephons-sitHoldingToolHammer-bottom-left-3',
        ],
        'lumephons-sitHoldingToolHammer-left': [
          'lumephons-sitHoldingToolHammer-left-0',
          'lumephons-sitHoldingToolHammer-left-1',
          'lumephons-sitHoldingToolHammer-left-2',
          'lumephons-sitHoldingToolHammer-left-3',
        ],
        'lumephons-sitHoldingToolHammer-top-left': [
          'lumephons-sitHoldingToolHammer-top-left-0',
          'lumephons-sitHoldingToolHammer-top-left-1',
          'lumephons-sitHoldingToolHammer-top-left-2',
          'lumephons-sitHoldingToolHammer-top-left-3',
        ],
        'lumephons-sitHoldingToolHammer-top': [
          'lumephons-sitHoldingToolHammer-top-0',
          'lumephons-sitHoldingToolHammer-top-1',
          'lumephons-sitHoldingToolHammer-top-2',
          'lumephons-sitHoldingToolHammer-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolPickaxe',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolPickaxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolPickaxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolPickaxe.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolPickaxe-bottom': [
          'lumephons-sitHoldingToolPickaxe-bottom-0',
          'lumephons-sitHoldingToolPickaxe-bottom-1',
          'lumephons-sitHoldingToolPickaxe-bottom-2',
          'lumephons-sitHoldingToolPickaxe-bottom-3',
        ],
        'lumephons-sitHoldingToolPickaxe-bottom-left': [
          'lumephons-sitHoldingToolPickaxe-bottom-left-0',
          'lumephons-sitHoldingToolPickaxe-bottom-left-1',
          'lumephons-sitHoldingToolPickaxe-bottom-left-2',
          'lumephons-sitHoldingToolPickaxe-bottom-left-3',
        ],
        'lumephons-sitHoldingToolPickaxe-left': [
          'lumephons-sitHoldingToolPickaxe-left-0',
          'lumephons-sitHoldingToolPickaxe-left-1',
          'lumephons-sitHoldingToolPickaxe-left-2',
          'lumephons-sitHoldingToolPickaxe-left-3',
        ],
        'lumephons-sitHoldingToolPickaxe-top-left': [
          'lumephons-sitHoldingToolPickaxe-top-left-0',
          'lumephons-sitHoldingToolPickaxe-top-left-1',
          'lumephons-sitHoldingToolPickaxe-top-left-2',
          'lumephons-sitHoldingToolPickaxe-top-left-3',
        ],
        'lumephons-sitHoldingToolPickaxe-top': [
          'lumephons-sitHoldingToolPickaxe-top-0',
          'lumephons-sitHoldingToolPickaxe-top-1',
          'lumephons-sitHoldingToolPickaxe-top-2',
          'lumephons-sitHoldingToolPickaxe-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolShowel',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolShowel-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolShowel.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolShowel-bottom': [
          'lumephons-sitHoldingToolShowel-bottom-0',
          'lumephons-sitHoldingToolShowel-bottom-1',
          'lumephons-sitHoldingToolShowel-bottom-2',
          'lumephons-sitHoldingToolShowel-bottom-3',
        ],
        'lumephons-sitHoldingToolShowel-bottom-left': [
          'lumephons-sitHoldingToolShowel-bottom-left-0',
          'lumephons-sitHoldingToolShowel-bottom-left-1',
          'lumephons-sitHoldingToolShowel-bottom-left-2',
          'lumephons-sitHoldingToolShowel-bottom-left-3',
        ],
        'lumephons-sitHoldingToolShowel-left': [
          'lumephons-sitHoldingToolShowel-left-0',
          'lumephons-sitHoldingToolShowel-left-1',
          'lumephons-sitHoldingToolShowel-left-2',
          'lumephons-sitHoldingToolShowel-left-3',
        ],
        'lumephons-sitHoldingToolShowel-top-left': [
          'lumephons-sitHoldingToolShowel-top-left-0',
          'lumephons-sitHoldingToolShowel-top-left-1',
          'lumephons-sitHoldingToolShowel-top-left-2',
          'lumephons-sitHoldingToolShowel-top-left-3',
        ],
        'lumephons-sitHoldingToolShowel-top': [
          'lumephons-sitHoldingToolShowel-top-0',
          'lumephons-sitHoldingToolShowel-top-1',
          'lumephons-sitHoldingToolShowel-top-2',
          'lumephons-sitHoldingToolShowel-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolSword',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolSword-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolSword.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolSword-bottom': [
          'lumephons-sitHoldingToolSword-bottom-0',
          'lumephons-sitHoldingToolSword-bottom-1',
          'lumephons-sitHoldingToolSword-bottom-2',
          'lumephons-sitHoldingToolSword-bottom-3',
        ],
        'lumephons-sitHoldingToolSword-bottom-left': [
          'lumephons-sitHoldingToolSword-bottom-left-0',
          'lumephons-sitHoldingToolSword-bottom-left-1',
          'lumephons-sitHoldingToolSword-bottom-left-2',
          'lumephons-sitHoldingToolSword-bottom-left-3',
        ],
        'lumephons-sitHoldingToolSword-left': [
          'lumephons-sitHoldingToolSword-left-0',
          'lumephons-sitHoldingToolSword-left-1',
          'lumephons-sitHoldingToolSword-left-2',
          'lumephons-sitHoldingToolSword-left-3',
        ],
        'lumephons-sitHoldingToolSword-top-left': [
          'lumephons-sitHoldingToolSword-top-left-0',
          'lumephons-sitHoldingToolSword-top-left-1',
          'lumephons-sitHoldingToolSword-top-left-2',
          'lumephons-sitHoldingToolSword-top-left-3',
        ],
        'lumephons-sitHoldingToolSword-top': [
          'lumephons-sitHoldingToolSword-top-0',
          'lumephons-sitHoldingToolSword-top-1',
          'lumephons-sitHoldingToolSword-top-2',
          'lumephons-sitHoldingToolSword-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-sitHoldingToolWaterCan',
    metadata: {
      frames: {
        'lumephons-sitHoldingToolWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-sitHoldingToolWaterCan-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/sitHoldingToolWaterCan.png',
        size: {
          w: 1840,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-sitHoldingToolWaterCan-bottom': [
          'lumephons-sitHoldingToolWaterCan-bottom-0',
          'lumephons-sitHoldingToolWaterCan-bottom-1',
          'lumephons-sitHoldingToolWaterCan-bottom-2',
          'lumephons-sitHoldingToolWaterCan-bottom-3',
        ],
        'lumephons-sitHoldingToolWaterCan-bottom-left': [
          'lumephons-sitHoldingToolWaterCan-bottom-left-0',
          'lumephons-sitHoldingToolWaterCan-bottom-left-1',
          'lumephons-sitHoldingToolWaterCan-bottom-left-2',
          'lumephons-sitHoldingToolWaterCan-bottom-left-3',
        ],
        'lumephons-sitHoldingToolWaterCan-left': [
          'lumephons-sitHoldingToolWaterCan-left-0',
          'lumephons-sitHoldingToolWaterCan-left-1',
          'lumephons-sitHoldingToolWaterCan-left-2',
          'lumephons-sitHoldingToolWaterCan-left-3',
        ],
        'lumephons-sitHoldingToolWaterCan-top-left': [
          'lumephons-sitHoldingToolWaterCan-top-left-0',
          'lumephons-sitHoldingToolWaterCan-top-left-1',
          'lumephons-sitHoldingToolWaterCan-top-left-2',
          'lumephons-sitHoldingToolWaterCan-top-left-3',
        ],
        'lumephons-sitHoldingToolWaterCan-top': [
          'lumephons-sitHoldingToolWaterCan-top-0',
          'lumephons-sitHoldingToolWaterCan-top-1',
          'lumephons-sitHoldingToolWaterCan-top-2',
          'lumephons-sitHoldingToolWaterCan-top-3',
        ],
      },
    },
  },
  {
    name: 'lumephons-swing',
    metadata: {
      frames: {
        'lumephons-swing-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swing-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/swing.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-swing-bottom': [
          'lumephons-swing-bottom-0',
          'lumephons-swing-bottom-1',
          'lumephons-swing-bottom-2',
          'lumephons-swing-bottom-3',
          'lumephons-swing-bottom-4',
          'lumephons-swing-bottom-5',
        ],
        'lumephons-swing-bottom-left': [
          'lumephons-swing-bottom-left-0',
          'lumephons-swing-bottom-left-1',
          'lumephons-swing-bottom-left-2',
          'lumephons-swing-bottom-left-3',
          'lumephons-swing-bottom-left-4',
          'lumephons-swing-bottom-left-5',
        ],
        'lumephons-swing-left': [
          'lumephons-swing-left-0',
          'lumephons-swing-left-1',
          'lumephons-swing-left-2',
          'lumephons-swing-left-3',
          'lumephons-swing-left-4',
          'lumephons-swing-left-5',
        ],
        'lumephons-swing-top-left': [
          'lumephons-swing-top-left-0',
          'lumephons-swing-top-left-1',
          'lumephons-swing-top-left-2',
          'lumephons-swing-top-left-3',
          'lumephons-swing-top-left-4',
          'lumephons-swing-top-left-5',
        ],
        'lumephons-swing-top': [
          'lumephons-swing-top-0',
          'lumephons-swing-top-1',
          'lumephons-swing-top-2',
          'lumephons-swing-top-3',
          'lumephons-swing-top-4',
          'lumephons-swing-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-swingAxe',
    metadata: {
      frames: {
        'lumephons-swingAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingAxe-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/swingAxe.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-swingAxe-bottom': [
          'lumephons-swingAxe-bottom-0',
          'lumephons-swingAxe-bottom-1',
          'lumephons-swingAxe-bottom-2',
          'lumephons-swingAxe-bottom-3',
          'lumephons-swingAxe-bottom-4',
          'lumephons-swingAxe-bottom-5',
        ],
        'lumephons-swingAxe-bottom-left': [
          'lumephons-swingAxe-bottom-left-0',
          'lumephons-swingAxe-bottom-left-1',
          'lumephons-swingAxe-bottom-left-2',
          'lumephons-swingAxe-bottom-left-3',
          'lumephons-swingAxe-bottom-left-4',
          'lumephons-swingAxe-bottom-left-5',
        ],
        'lumephons-swingAxe-left': [
          'lumephons-swingAxe-left-0',
          'lumephons-swingAxe-left-1',
          'lumephons-swingAxe-left-2',
          'lumephons-swingAxe-left-3',
          'lumephons-swingAxe-left-4',
          'lumephons-swingAxe-left-5',
        ],
        'lumephons-swingAxe-top-left': [
          'lumephons-swingAxe-top-left-0',
          'lumephons-swingAxe-top-left-1',
          'lumephons-swingAxe-top-left-2',
          'lumephons-swingAxe-top-left-3',
          'lumephons-swingAxe-top-left-4',
          'lumephons-swingAxe-top-left-5',
        ],
        'lumephons-swingAxe-top': [
          'lumephons-swingAxe-top-0',
          'lumephons-swingAxe-top-1',
          'lumephons-swingAxe-top-2',
          'lumephons-swingAxe-top-3',
          'lumephons-swingAxe-top-4',
          'lumephons-swingAxe-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-swingHammer',
    metadata: {
      frames: {
        'lumephons-swingHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingHammer-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/swingHammer.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-swingHammer-bottom': [
          'lumephons-swingHammer-bottom-0',
          'lumephons-swingHammer-bottom-1',
          'lumephons-swingHammer-bottom-2',
          'lumephons-swingHammer-bottom-3',
          'lumephons-swingHammer-bottom-4',
          'lumephons-swingHammer-bottom-5',
        ],
        'lumephons-swingHammer-bottom-left': [
          'lumephons-swingHammer-bottom-left-0',
          'lumephons-swingHammer-bottom-left-1',
          'lumephons-swingHammer-bottom-left-2',
          'lumephons-swingHammer-bottom-left-3',
          'lumephons-swingHammer-bottom-left-4',
          'lumephons-swingHammer-bottom-left-5',
        ],
        'lumephons-swingHammer-left': [
          'lumephons-swingHammer-left-0',
          'lumephons-swingHammer-left-1',
          'lumephons-swingHammer-left-2',
          'lumephons-swingHammer-left-3',
          'lumephons-swingHammer-left-4',
          'lumephons-swingHammer-left-5',
        ],
        'lumephons-swingHammer-top-left': [
          'lumephons-swingHammer-top-left-0',
          'lumephons-swingHammer-top-left-1',
          'lumephons-swingHammer-top-left-2',
          'lumephons-swingHammer-top-left-3',
          'lumephons-swingHammer-top-left-4',
          'lumephons-swingHammer-top-left-5',
        ],
        'lumephons-swingHammer-top': [
          'lumephons-swingHammer-top-0',
          'lumephons-swingHammer-top-1',
          'lumephons-swingHammer-top-2',
          'lumephons-swingHammer-top-3',
          'lumephons-swingHammer-top-4',
          'lumephons-swingHammer-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-swingPickAxe',
    metadata: {
      frames: {
        'lumephons-swingPickAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swingPickAxe-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/swingPickAxe.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-swingPickAxe-bottom': [
          'lumephons-swingPickAxe-bottom-0',
          'lumephons-swingPickAxe-bottom-1',
          'lumephons-swingPickAxe-bottom-2',
          'lumephons-swingPickAxe-bottom-3',
          'lumephons-swingPickAxe-bottom-4',
          'lumephons-swingPickAxe-bottom-5',
        ],
        'lumephons-swingPickAxe-bottom-left': [
          'lumephons-swingPickAxe-bottom-left-0',
          'lumephons-swingPickAxe-bottom-left-1',
          'lumephons-swingPickAxe-bottom-left-2',
          'lumephons-swingPickAxe-bottom-left-3',
          'lumephons-swingPickAxe-bottom-left-4',
          'lumephons-swingPickAxe-bottom-left-5',
        ],
        'lumephons-swingPickAxe-left': [
          'lumephons-swingPickAxe-left-0',
          'lumephons-swingPickAxe-left-1',
          'lumephons-swingPickAxe-left-2',
          'lumephons-swingPickAxe-left-3',
          'lumephons-swingPickAxe-left-4',
          'lumephons-swingPickAxe-left-5',
        ],
        'lumephons-swingPickAxe-top-left': [
          'lumephons-swingPickAxe-top-left-0',
          'lumephons-swingPickAxe-top-left-1',
          'lumephons-swingPickAxe-top-left-2',
          'lumephons-swingPickAxe-top-left-3',
          'lumephons-swingPickAxe-top-left-4',
          'lumephons-swingPickAxe-top-left-5',
        ],
        'lumephons-swingPickAxe-top': [
          'lumephons-swingPickAxe-top-0',
          'lumephons-swingPickAxe-top-1',
          'lumephons-swingPickAxe-top-2',
          'lumephons-swingPickAxe-top-3',
          'lumephons-swingPickAxe-top-4',
          'lumephons-swingPickAxe-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-swordAttack',
    metadata: {
      frames: {
        'lumephons-swordAttack-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttack-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/swordAttack.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-swordAttack-bottom': [
          'lumephons-swordAttack-bottom-0',
          'lumephons-swordAttack-bottom-1',
          'lumephons-swordAttack-bottom-2',
          'lumephons-swordAttack-bottom-3',
          'lumephons-swordAttack-bottom-4',
          'lumephons-swordAttack-bottom-5',
        ],
        'lumephons-swordAttack-bottom-left': [
          'lumephons-swordAttack-bottom-left-0',
          'lumephons-swordAttack-bottom-left-1',
          'lumephons-swordAttack-bottom-left-2',
          'lumephons-swordAttack-bottom-left-3',
          'lumephons-swordAttack-bottom-left-4',
          'lumephons-swordAttack-bottom-left-5',
        ],
        'lumephons-swordAttack-left': [
          'lumephons-swordAttack-left-0',
          'lumephons-swordAttack-left-1',
          'lumephons-swordAttack-left-2',
          'lumephons-swordAttack-left-3',
          'lumephons-swordAttack-left-4',
          'lumephons-swordAttack-left-5',
        ],
        'lumephons-swordAttack-top-left': [
          'lumephons-swordAttack-top-left-0',
          'lumephons-swordAttack-top-left-1',
          'lumephons-swordAttack-top-left-2',
          'lumephons-swordAttack-top-left-3',
          'lumephons-swordAttack-top-left-4',
          'lumephons-swordAttack-top-left-5',
        ],
        'lumephons-swordAttack-top': [
          'lumephons-swordAttack-top-0',
          'lumephons-swordAttack-top-1',
          'lumephons-swordAttack-top-2',
          'lumephons-swordAttack-top-3',
          'lumephons-swordAttack-top-4',
          'lumephons-swordAttack-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-swordAttackSword',
    metadata: {
      frames: {
        'lumephons-swordAttackSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-swordAttackSword-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/swordAttackSword.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-swordAttackSword-bottom': [
          'lumephons-swordAttackSword-bottom-0',
          'lumephons-swordAttackSword-bottom-1',
          'lumephons-swordAttackSword-bottom-2',
          'lumephons-swordAttackSword-bottom-3',
          'lumephons-swordAttackSword-bottom-4',
          'lumephons-swordAttackSword-bottom-5',
        ],
        'lumephons-swordAttackSword-bottom-left': [
          'lumephons-swordAttackSword-bottom-left-0',
          'lumephons-swordAttackSword-bottom-left-1',
          'lumephons-swordAttackSword-bottom-left-2',
          'lumephons-swordAttackSword-bottom-left-3',
          'lumephons-swordAttackSword-bottom-left-4',
          'lumephons-swordAttackSword-bottom-left-5',
        ],
        'lumephons-swordAttackSword-left': [
          'lumephons-swordAttackSword-left-0',
          'lumephons-swordAttackSword-left-1',
          'lumephons-swordAttackSword-left-2',
          'lumephons-swordAttackSword-left-3',
          'lumephons-swordAttackSword-left-4',
          'lumephons-swordAttackSword-left-5',
        ],
        'lumephons-swordAttackSword-top-left': [
          'lumephons-swordAttackSword-top-left-0',
          'lumephons-swordAttackSword-top-left-1',
          'lumephons-swordAttackSword-top-left-2',
          'lumephons-swordAttackSword-top-left-3',
          'lumephons-swordAttackSword-top-left-4',
          'lumephons-swordAttackSword-top-left-5',
        ],
        'lumephons-swordAttackSword-top': [
          'lumephons-swordAttackSword-top-0',
          'lumephons-swordAttackSword-top-1',
          'lumephons-swordAttackSword-top-2',
          'lumephons-swordAttackSword-top-3',
          'lumephons-swordAttackSword-top-4',
          'lumephons-swordAttackSword-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walk',
    metadata: {
      frames: {
        'lumephons-walk-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walk-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walk.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walk-bottom': [
          'lumephons-walk-bottom-0',
          'lumephons-walk-bottom-1',
          'lumephons-walk-bottom-2',
          'lumephons-walk-bottom-3',
          'lumephons-walk-bottom-4',
          'lumephons-walk-bottom-5',
        ],
        'lumephons-walk-bottom-left': [
          'lumephons-walk-bottom-left-0',
          'lumephons-walk-bottom-left-1',
          'lumephons-walk-bottom-left-2',
          'lumephons-walk-bottom-left-3',
          'lumephons-walk-bottom-left-4',
          'lumephons-walk-bottom-left-5',
        ],
        'lumephons-walk-left': [
          'lumephons-walk-left-0',
          'lumephons-walk-left-1',
          'lumephons-walk-left-2',
          'lumephons-walk-left-3',
          'lumephons-walk-left-4',
          'lumephons-walk-left-5',
        ],
        'lumephons-walk-top-left': [
          'lumephons-walk-top-left-0',
          'lumephons-walk-top-left-1',
          'lumephons-walk-top-left-2',
          'lumephons-walk-top-left-3',
          'lumephons-walk-top-left-4',
          'lumephons-walk-top-left-5',
        ],
        'lumephons-walk-top': [
          'lumephons-walk-top-0',
          'lumephons-walk-top-1',
          'lumephons-walk-top-2',
          'lumephons-walk-top-3',
          'lumephons-walk-top-4',
          'lumephons-walk-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingTool',
    metadata: {
      frames: {
        'lumephons-walkHoldingTool-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingTool-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingTool.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingTool-bottom': [
          'lumephons-walkHoldingTool-bottom-0',
          'lumephons-walkHoldingTool-bottom-1',
          'lumephons-walkHoldingTool-bottom-2',
          'lumephons-walkHoldingTool-bottom-3',
          'lumephons-walkHoldingTool-bottom-4',
          'lumephons-walkHoldingTool-bottom-5',
        ],
        'lumephons-walkHoldingTool-bottom-left': [
          'lumephons-walkHoldingTool-bottom-left-0',
          'lumephons-walkHoldingTool-bottom-left-1',
          'lumephons-walkHoldingTool-bottom-left-2',
          'lumephons-walkHoldingTool-bottom-left-3',
          'lumephons-walkHoldingTool-bottom-left-4',
          'lumephons-walkHoldingTool-bottom-left-5',
        ],
        'lumephons-walkHoldingTool-left': [
          'lumephons-walkHoldingTool-left-0',
          'lumephons-walkHoldingTool-left-1',
          'lumephons-walkHoldingTool-left-2',
          'lumephons-walkHoldingTool-left-3',
          'lumephons-walkHoldingTool-left-4',
          'lumephons-walkHoldingTool-left-5',
        ],
        'lumephons-walkHoldingTool-top-left': [
          'lumephons-walkHoldingTool-top-left-0',
          'lumephons-walkHoldingTool-top-left-1',
          'lumephons-walkHoldingTool-top-left-2',
          'lumephons-walkHoldingTool-top-left-3',
          'lumephons-walkHoldingTool-top-left-4',
          'lumephons-walkHoldingTool-top-left-5',
        ],
        'lumephons-walkHoldingTool-top': [
          'lumephons-walkHoldingTool-top-0',
          'lumephons-walkHoldingTool-top-1',
          'lumephons-walkHoldingTool-top-2',
          'lumephons-walkHoldingTool-top-3',
          'lumephons-walkHoldingTool-top-4',
          'lumephons-walkHoldingTool-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolAxe',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolAxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolAxe-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolAxe.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolAxe-bottom': [
          'lumephons-walkHoldingToolAxe-bottom-0',
          'lumephons-walkHoldingToolAxe-bottom-1',
          'lumephons-walkHoldingToolAxe-bottom-2',
          'lumephons-walkHoldingToolAxe-bottom-3',
          'lumephons-walkHoldingToolAxe-bottom-4',
          'lumephons-walkHoldingToolAxe-bottom-5',
        ],
        'lumephons-walkHoldingToolAxe-bottom-left': [
          'lumephons-walkHoldingToolAxe-bottom-left-0',
          'lumephons-walkHoldingToolAxe-bottom-left-1',
          'lumephons-walkHoldingToolAxe-bottom-left-2',
          'lumephons-walkHoldingToolAxe-bottom-left-3',
          'lumephons-walkHoldingToolAxe-bottom-left-4',
          'lumephons-walkHoldingToolAxe-bottom-left-5',
        ],
        'lumephons-walkHoldingToolAxe-left': [
          'lumephons-walkHoldingToolAxe-left-0',
          'lumephons-walkHoldingToolAxe-left-1',
          'lumephons-walkHoldingToolAxe-left-2',
          'lumephons-walkHoldingToolAxe-left-3',
          'lumephons-walkHoldingToolAxe-left-4',
          'lumephons-walkHoldingToolAxe-left-5',
        ],
        'lumephons-walkHoldingToolAxe-top-left': [
          'lumephons-walkHoldingToolAxe-top-left-0',
          'lumephons-walkHoldingToolAxe-top-left-1',
          'lumephons-walkHoldingToolAxe-top-left-2',
          'lumephons-walkHoldingToolAxe-top-left-3',
          'lumephons-walkHoldingToolAxe-top-left-4',
          'lumephons-walkHoldingToolAxe-top-left-5',
        ],
        'lumephons-walkHoldingToolAxe-top': [
          'lumephons-walkHoldingToolAxe-top-0',
          'lumephons-walkHoldingToolAxe-top-1',
          'lumephons-walkHoldingToolAxe-top-2',
          'lumephons-walkHoldingToolAxe-top-3',
          'lumephons-walkHoldingToolAxe-top-4',
          'lumephons-walkHoldingToolAxe-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolFishingpole',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolFishingpole-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolFishingpole-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolFishingpole.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolFishingpole-bottom': [
          'lumephons-walkHoldingToolFishingpole-bottom-0',
          'lumephons-walkHoldingToolFishingpole-bottom-1',
          'lumephons-walkHoldingToolFishingpole-bottom-2',
          'lumephons-walkHoldingToolFishingpole-bottom-3',
          'lumephons-walkHoldingToolFishingpole-bottom-4',
          'lumephons-walkHoldingToolFishingpole-bottom-5',
        ],
        'lumephons-walkHoldingToolFishingpole-bottom-left': [
          'lumephons-walkHoldingToolFishingpole-bottom-left-0',
          'lumephons-walkHoldingToolFishingpole-bottom-left-1',
          'lumephons-walkHoldingToolFishingpole-bottom-left-2',
          'lumephons-walkHoldingToolFishingpole-bottom-left-3',
          'lumephons-walkHoldingToolFishingpole-bottom-left-4',
          'lumephons-walkHoldingToolFishingpole-bottom-left-5',
        ],
        'lumephons-walkHoldingToolFishingpole-left': [
          'lumephons-walkHoldingToolFishingpole-left-0',
          'lumephons-walkHoldingToolFishingpole-left-1',
          'lumephons-walkHoldingToolFishingpole-left-2',
          'lumephons-walkHoldingToolFishingpole-left-3',
          'lumephons-walkHoldingToolFishingpole-left-4',
          'lumephons-walkHoldingToolFishingpole-left-5',
        ],
        'lumephons-walkHoldingToolFishingpole-top-left': [
          'lumephons-walkHoldingToolFishingpole-top-left-0',
          'lumephons-walkHoldingToolFishingpole-top-left-1',
          'lumephons-walkHoldingToolFishingpole-top-left-2',
          'lumephons-walkHoldingToolFishingpole-top-left-3',
          'lumephons-walkHoldingToolFishingpole-top-left-4',
          'lumephons-walkHoldingToolFishingpole-top-left-5',
        ],
        'lumephons-walkHoldingToolFishingpole-top': [
          'lumephons-walkHoldingToolFishingpole-top-0',
          'lumephons-walkHoldingToolFishingpole-top-1',
          'lumephons-walkHoldingToolFishingpole-top-2',
          'lumephons-walkHoldingToolFishingpole-top-3',
          'lumephons-walkHoldingToolFishingpole-top-4',
          'lumephons-walkHoldingToolFishingpole-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolHammer',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolHammer-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolHammer-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolHammer.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolHammer-bottom': [
          'lumephons-walkHoldingToolHammer-bottom-0',
          'lumephons-walkHoldingToolHammer-bottom-1',
          'lumephons-walkHoldingToolHammer-bottom-2',
          'lumephons-walkHoldingToolHammer-bottom-3',
          'lumephons-walkHoldingToolHammer-bottom-4',
          'lumephons-walkHoldingToolHammer-bottom-5',
        ],
        'lumephons-walkHoldingToolHammer-bottom-left': [
          'lumephons-walkHoldingToolHammer-bottom-left-0',
          'lumephons-walkHoldingToolHammer-bottom-left-1',
          'lumephons-walkHoldingToolHammer-bottom-left-2',
          'lumephons-walkHoldingToolHammer-bottom-left-3',
          'lumephons-walkHoldingToolHammer-bottom-left-4',
          'lumephons-walkHoldingToolHammer-bottom-left-5',
        ],
        'lumephons-walkHoldingToolHammer-left': [
          'lumephons-walkHoldingToolHammer-left-0',
          'lumephons-walkHoldingToolHammer-left-1',
          'lumephons-walkHoldingToolHammer-left-2',
          'lumephons-walkHoldingToolHammer-left-3',
          'lumephons-walkHoldingToolHammer-left-4',
          'lumephons-walkHoldingToolHammer-left-5',
        ],
        'lumephons-walkHoldingToolHammer-top-left': [
          'lumephons-walkHoldingToolHammer-top-left-0',
          'lumephons-walkHoldingToolHammer-top-left-1',
          'lumephons-walkHoldingToolHammer-top-left-2',
          'lumephons-walkHoldingToolHammer-top-left-3',
          'lumephons-walkHoldingToolHammer-top-left-4',
          'lumephons-walkHoldingToolHammer-top-left-5',
        ],
        'lumephons-walkHoldingToolHammer-top': [
          'lumephons-walkHoldingToolHammer-top-0',
          'lumephons-walkHoldingToolHammer-top-1',
          'lumephons-walkHoldingToolHammer-top-2',
          'lumephons-walkHoldingToolHammer-top-3',
          'lumephons-walkHoldingToolHammer-top-4',
          'lumephons-walkHoldingToolHammer-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolPickaxe',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolPickaxe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolPickaxe-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolPickaxe.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolPickaxe-bottom': [
          'lumephons-walkHoldingToolPickaxe-bottom-0',
          'lumephons-walkHoldingToolPickaxe-bottom-1',
          'lumephons-walkHoldingToolPickaxe-bottom-2',
          'lumephons-walkHoldingToolPickaxe-bottom-3',
          'lumephons-walkHoldingToolPickaxe-bottom-4',
          'lumephons-walkHoldingToolPickaxe-bottom-5',
        ],
        'lumephons-walkHoldingToolPickaxe-bottom-left': [
          'lumephons-walkHoldingToolPickaxe-bottom-left-0',
          'lumephons-walkHoldingToolPickaxe-bottom-left-1',
          'lumephons-walkHoldingToolPickaxe-bottom-left-2',
          'lumephons-walkHoldingToolPickaxe-bottom-left-3',
          'lumephons-walkHoldingToolPickaxe-bottom-left-4',
          'lumephons-walkHoldingToolPickaxe-bottom-left-5',
        ],
        'lumephons-walkHoldingToolPickaxe-left': [
          'lumephons-walkHoldingToolPickaxe-left-0',
          'lumephons-walkHoldingToolPickaxe-left-1',
          'lumephons-walkHoldingToolPickaxe-left-2',
          'lumephons-walkHoldingToolPickaxe-left-3',
          'lumephons-walkHoldingToolPickaxe-left-4',
          'lumephons-walkHoldingToolPickaxe-left-5',
        ],
        'lumephons-walkHoldingToolPickaxe-top-left': [
          'lumephons-walkHoldingToolPickaxe-top-left-0',
          'lumephons-walkHoldingToolPickaxe-top-left-1',
          'lumephons-walkHoldingToolPickaxe-top-left-2',
          'lumephons-walkHoldingToolPickaxe-top-left-3',
          'lumephons-walkHoldingToolPickaxe-top-left-4',
          'lumephons-walkHoldingToolPickaxe-top-left-5',
        ],
        'lumephons-walkHoldingToolPickaxe-top': [
          'lumephons-walkHoldingToolPickaxe-top-0',
          'lumephons-walkHoldingToolPickaxe-top-1',
          'lumephons-walkHoldingToolPickaxe-top-2',
          'lumephons-walkHoldingToolPickaxe-top-3',
          'lumephons-walkHoldingToolPickaxe-top-4',
          'lumephons-walkHoldingToolPickaxe-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolShowel',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolShowel-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolShowel-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolShowel.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolShowel-bottom': [
          'lumephons-walkHoldingToolShowel-bottom-0',
          'lumephons-walkHoldingToolShowel-bottom-1',
          'lumephons-walkHoldingToolShowel-bottom-2',
          'lumephons-walkHoldingToolShowel-bottom-3',
          'lumephons-walkHoldingToolShowel-bottom-4',
          'lumephons-walkHoldingToolShowel-bottom-5',
        ],
        'lumephons-walkHoldingToolShowel-bottom-left': [
          'lumephons-walkHoldingToolShowel-bottom-left-0',
          'lumephons-walkHoldingToolShowel-bottom-left-1',
          'lumephons-walkHoldingToolShowel-bottom-left-2',
          'lumephons-walkHoldingToolShowel-bottom-left-3',
          'lumephons-walkHoldingToolShowel-bottom-left-4',
          'lumephons-walkHoldingToolShowel-bottom-left-5',
        ],
        'lumephons-walkHoldingToolShowel-left': [
          'lumephons-walkHoldingToolShowel-left-0',
          'lumephons-walkHoldingToolShowel-left-1',
          'lumephons-walkHoldingToolShowel-left-2',
          'lumephons-walkHoldingToolShowel-left-3',
          'lumephons-walkHoldingToolShowel-left-4',
          'lumephons-walkHoldingToolShowel-left-5',
        ],
        'lumephons-walkHoldingToolShowel-top-left': [
          'lumephons-walkHoldingToolShowel-top-left-0',
          'lumephons-walkHoldingToolShowel-top-left-1',
          'lumephons-walkHoldingToolShowel-top-left-2',
          'lumephons-walkHoldingToolShowel-top-left-3',
          'lumephons-walkHoldingToolShowel-top-left-4',
          'lumephons-walkHoldingToolShowel-top-left-5',
        ],
        'lumephons-walkHoldingToolShowel-top': [
          'lumephons-walkHoldingToolShowel-top-0',
          'lumephons-walkHoldingToolShowel-top-1',
          'lumephons-walkHoldingToolShowel-top-2',
          'lumephons-walkHoldingToolShowel-top-3',
          'lumephons-walkHoldingToolShowel-top-4',
          'lumephons-walkHoldingToolShowel-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolSilver',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolSilver-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSilver-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolSilver.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolSilver-bottom': [
          'lumephons-walkHoldingToolSilver-bottom-0',
          'lumephons-walkHoldingToolSilver-bottom-1',
          'lumephons-walkHoldingToolSilver-bottom-2',
          'lumephons-walkHoldingToolSilver-bottom-3',
          'lumephons-walkHoldingToolSilver-bottom-4',
          'lumephons-walkHoldingToolSilver-bottom-5',
        ],
        'lumephons-walkHoldingToolSilver-bottom-left': [
          'lumephons-walkHoldingToolSilver-bottom-left-0',
          'lumephons-walkHoldingToolSilver-bottom-left-1',
          'lumephons-walkHoldingToolSilver-bottom-left-2',
          'lumephons-walkHoldingToolSilver-bottom-left-3',
          'lumephons-walkHoldingToolSilver-bottom-left-4',
          'lumephons-walkHoldingToolSilver-bottom-left-5',
        ],
        'lumephons-walkHoldingToolSilver-left': [
          'lumephons-walkHoldingToolSilver-left-0',
          'lumephons-walkHoldingToolSilver-left-1',
          'lumephons-walkHoldingToolSilver-left-2',
          'lumephons-walkHoldingToolSilver-left-3',
          'lumephons-walkHoldingToolSilver-left-4',
          'lumephons-walkHoldingToolSilver-left-5',
        ],
        'lumephons-walkHoldingToolSilver-top-left': [
          'lumephons-walkHoldingToolSilver-top-left-0',
          'lumephons-walkHoldingToolSilver-top-left-1',
          'lumephons-walkHoldingToolSilver-top-left-2',
          'lumephons-walkHoldingToolSilver-top-left-3',
          'lumephons-walkHoldingToolSilver-top-left-4',
          'lumephons-walkHoldingToolSilver-top-left-5',
        ],
        'lumephons-walkHoldingToolSilver-top': [
          'lumephons-walkHoldingToolSilver-top-0',
          'lumephons-walkHoldingToolSilver-top-1',
          'lumephons-walkHoldingToolSilver-top-2',
          'lumephons-walkHoldingToolSilver-top-3',
          'lumephons-walkHoldingToolSilver-top-4',
          'lumephons-walkHoldingToolSilver-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolSword',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolSword-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolSword-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolSword.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolSword-bottom': [
          'lumephons-walkHoldingToolSword-bottom-0',
          'lumephons-walkHoldingToolSword-bottom-1',
          'lumephons-walkHoldingToolSword-bottom-2',
          'lumephons-walkHoldingToolSword-bottom-3',
          'lumephons-walkHoldingToolSword-bottom-4',
          'lumephons-walkHoldingToolSword-bottom-5',
        ],
        'lumephons-walkHoldingToolSword-bottom-left': [
          'lumephons-walkHoldingToolSword-bottom-left-0',
          'lumephons-walkHoldingToolSword-bottom-left-1',
          'lumephons-walkHoldingToolSword-bottom-left-2',
          'lumephons-walkHoldingToolSword-bottom-left-3',
          'lumephons-walkHoldingToolSword-bottom-left-4',
          'lumephons-walkHoldingToolSword-bottom-left-5',
        ],
        'lumephons-walkHoldingToolSword-left': [
          'lumephons-walkHoldingToolSword-left-0',
          'lumephons-walkHoldingToolSword-left-1',
          'lumephons-walkHoldingToolSword-left-2',
          'lumephons-walkHoldingToolSword-left-3',
          'lumephons-walkHoldingToolSword-left-4',
          'lumephons-walkHoldingToolSword-left-5',
        ],
        'lumephons-walkHoldingToolSword-top-left': [
          'lumephons-walkHoldingToolSword-top-left-0',
          'lumephons-walkHoldingToolSword-top-left-1',
          'lumephons-walkHoldingToolSword-top-left-2',
          'lumephons-walkHoldingToolSword-top-left-3',
          'lumephons-walkHoldingToolSword-top-left-4',
          'lumephons-walkHoldingToolSword-top-left-5',
        ],
        'lumephons-walkHoldingToolSword-top': [
          'lumephons-walkHoldingToolSword-top-0',
          'lumephons-walkHoldingToolSword-top-1',
          'lumephons-walkHoldingToolSword-top-2',
          'lumephons-walkHoldingToolSword-top-3',
          'lumephons-walkHoldingToolSword-top-4',
          'lumephons-walkHoldingToolSword-top-5',
        ],
      },
    },
  },
  {
    name: 'lumephons-walkHoldingToolWaterCan',
    metadata: {
      frames: {
        'lumephons-walkHoldingToolWaterCan-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-1': {
          frame: {
            x: 460,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-2': {
          frame: {
            x: 920,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-3': {
          frame: {
            x: 1380,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-4': {
          frame: {
            x: 1840,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-5': {
          frame: {
            x: 2300,
            y: 0,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-left-0': {
          frame: {
            x: 0,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-left-1': {
          frame: {
            x: 460,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-left-2': {
          frame: {
            x: 920,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-left-3': {
          frame: {
            x: 1380,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-left-4': {
          frame: {
            x: 1840,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-bottom-left-5': {
          frame: {
            x: 2300,
            y: 460,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-left-0': {
          frame: {
            x: 0,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-left-1': {
          frame: {
            x: 460,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-left-2': {
          frame: {
            x: 920,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-left-3': {
          frame: {
            x: 1380,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-left-4': {
          frame: {
            x: 1840,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-left-5': {
          frame: {
            x: 2300,
            y: 920,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-left-0': {
          frame: {
            x: 0,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-left-1': {
          frame: {
            x: 460,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-left-2': {
          frame: {
            x: 920,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-left-3': {
          frame: {
            x: 1380,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-left-4': {
          frame: {
            x: 1840,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-left-5': {
          frame: {
            x: 2300,
            y: 1380,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-0': {
          frame: {
            x: 0,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-1': {
          frame: {
            x: 460,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-2': {
          frame: {
            x: 920,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-3': {
          frame: {
            x: 1380,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-4': {
          frame: {
            x: 1840,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
        'lumephons-walkHoldingToolWaterCan-top-5': {
          frame: {
            x: 2300,
            y: 1840,
            w: 460,
            h: 460,
          },
          sourceSize: {
            w: 460,
            h: 460,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 460,
            h: 460,
          },
        },
      },
      meta: {
        image: '/sprites/entities/lumephons/walkHoldingToolWaterCan.png',
        size: {
          w: 2760,
          h: 2300,
        },
        scale: '1',
      },
      animations: {
        'lumephons-walkHoldingToolWaterCan-bottom': [
          'lumephons-walkHoldingToolWaterCan-bottom-0',
          'lumephons-walkHoldingToolWaterCan-bottom-1',
          'lumephons-walkHoldingToolWaterCan-bottom-2',
          'lumephons-walkHoldingToolWaterCan-bottom-3',
          'lumephons-walkHoldingToolWaterCan-bottom-4',
          'lumephons-walkHoldingToolWaterCan-bottom-5',
        ],
        'lumephons-walkHoldingToolWaterCan-bottom-left': [
          'lumephons-walkHoldingToolWaterCan-bottom-left-0',
          'lumephons-walkHoldingToolWaterCan-bottom-left-1',
          'lumephons-walkHoldingToolWaterCan-bottom-left-2',
          'lumephons-walkHoldingToolWaterCan-bottom-left-3',
          'lumephons-walkHoldingToolWaterCan-bottom-left-4',
          'lumephons-walkHoldingToolWaterCan-bottom-left-5',
        ],
        'lumephons-walkHoldingToolWaterCan-left': [
          'lumephons-walkHoldingToolWaterCan-left-0',
          'lumephons-walkHoldingToolWaterCan-left-1',
          'lumephons-walkHoldingToolWaterCan-left-2',
          'lumephons-walkHoldingToolWaterCan-left-3',
          'lumephons-walkHoldingToolWaterCan-left-4',
          'lumephons-walkHoldingToolWaterCan-left-5',
        ],
        'lumephons-walkHoldingToolWaterCan-top-left': [
          'lumephons-walkHoldingToolWaterCan-top-left-0',
          'lumephons-walkHoldingToolWaterCan-top-left-1',
          'lumephons-walkHoldingToolWaterCan-top-left-2',
          'lumephons-walkHoldingToolWaterCan-top-left-3',
          'lumephons-walkHoldingToolWaterCan-top-left-4',
          'lumephons-walkHoldingToolWaterCan-top-left-5',
        ],
        'lumephons-walkHoldingToolWaterCan-top': [
          'lumephons-walkHoldingToolWaterCan-top-0',
          'lumephons-walkHoldingToolWaterCan-top-1',
          'lumephons-walkHoldingToolWaterCan-top-2',
          'lumephons-walkHoldingToolWaterCan-top-3',
          'lumephons-walkHoldingToolWaterCan-top-4',
          'lumephons-walkHoldingToolWaterCan-top-5',
        ],
      },
    },
  },
];
